{
  "_license": "Copyright (c) 2025 Goffy. This file belongs to Goffy. All Rights Reserved.",
  "course": {
    "error": "Kan ikke indlæse golfklubber",
    "insecure": "Bruger en standardplacering (kræver HTTPS for præcis position).",
    "label": "Brug nærmeste golfklub",
    "enableLocationHint": "(Aktivér placering for detta)",
    "loading": "Find golfklubber",
    "none": "Ingen golfklubber i nærheden",
    "permissionDenied": "Placeringstilladelse nægtet",
    "helpLabel": "Hjælp for placering",
    "helpTitle": "Aktivér placering for nærmeste golfklub",
    "helpDescription": "Tillad placeringsadgang i browseren eller enhedens indstillinger for automatisk at finde klubber i nærheden.",
    "refresh": "Opdater",
    "select": "Vælg golfklubb"
  },
  "appError": {
    "title": "Noget gik galt",
    "message": "Indlæs om sidan. Om problemet kvarstår, kontakta support.",
    "retry": "Prøv igen"
  },
  "edit": {
    "autosave": "Ändra texten, gemme filen så opdateres din app automatisk.",
    "help": "Tryk her, hvis din app ikke opdateres automatisk efter at du har gjort ændringer",
    "openCode": "Åbn koden for denne skærm:"
  },
  "menu": {
    "adminTools": "Adminværktøjer",
    "profile": "Profil",
    "statistics": "Statistik",
    "about": "Tjenestestatus",
    "aboutTitle": "Tjenestestatus",
    "aboutLoading": "Henter status...",
    "aboutEmpty": "Ingen statusdata tilgængelig.",
    "aboutError": "Fel:",
    "aboutLoadError": "Kunne ikke hente status.",
    "aboutUnknownService": "Ukendt tjeneste",
    "aboutUnknownImage": "Ukendt billede",
    "viewAs": "Vis som…",
    "viewAsActive": "Vis som: {role}",
    "viewAsTitle": "Vis appen som rolle",
    "viewAsHint": "Kun visning – serveren håndhæver stadig dine rigtige roller.",
    "viewAsDeveloper": "Udvikler",
    "viewAsAdmin": "Administrator",
    "viewAsPaidUser": "Betalende bruger",
    "viewAsUser": "Bruger",
    "viewAsPlayer": "Spiller (ingen roller)",
    "viewAsReset": "Nulstil til mine rigtige roller",
    "home": "Hjem",
    "friends": "Venner",
    "hole": "Hul",
    "selectGames": "Vælg spil",
    "tour": "Tour",
    "tourSettings": "Tour-indstillinger",
    "tourLeaderboard": "Tour-ledertavle",
    "golfCourses": "Golfbaner",
    "gameCalculator": "Game Calculator",
    "golfGamesAdmin": "Golf Games Admin",
    "configCourse": "Konfigurer bane",
    "scoreAllHoles": "Indtast alle huller (debug)",
    "scoreAllHolesRunning": "Indtaster resultater…",
    "scoreAllHolesDone": "Indtastede {scores} resultater på {holes} huller for {players} spillere. Hændelser: {events}, mystery: {mystery}.",
    "scoreAllHolesError": "Kunne ikke indtaste alle huller.",
    "roundInfo": "Rundeinformation",
    "roundInfoLoading": "Indlæser rundeinformation…",
    "roundInfoError": "Kunne ikke indlæse rundeinformation.",
    "roundInfoCopy": "Kopiér",
    "scoreAllHolesCountLabel": "Hvor mange huller skal udfyldes?",
    "scoreAllHolesStart": "Indtast",
    "scoreAllHolesImport": "Importér fil…",
    "scoreAllHolesClean": "Ryd eksisterende spillere og scores før import",
    "scoreAllHolesImportHint": "Importfil: opret den med tools/game-calculator/fetch-round-scores.py export <ROUND_ID> (prod-DB via ./scripts/open_ports_ssm.py). Spillere matches på navn, spil og scores afspilles på denne runde.",
    "scoreAllHolesImportError": "Kunne ikke importere rundefil.",
    "scoreAllHolesHole": "Hul {hole} (par {par})",
    "scoreAllHolesRow": "{name}: {strokes}",
    "scoreAllHolesMystery": "Mystery-vindere",
    "scoreAllHolesMysteryRow": "Hul {hole}: {name}",
    "ok": "OK",
    "roundResults": "Runde",
    "scorecard": "Scorekort",
    "holeView": "Visning",
    "more": "Meny",
    "back": "<- Tilbage",
    "logout": "Log ud",
    "close": "Luk",
    "anonymous": "Gæst",
    "privacy": "Privatlivspolitik",
    "courseMapping": "Banekortlægning",
    "courseMappingReview": "Gennemgå banekortlægning",
    "manageSubscription": "Administrer abonnement",
    "paymentsAdmin": "Betalinger og abonnementer",
    "golfCourseAdmin": "Golfbaneadministration",
    "terms": "Tjenestevilkår",
    "appInfo": "Om",
    "reportBug": "Rapportér bug",
    "reportBugTitle": "Rapportér bug",
    "reportBugHint": "Beskriv hvad der skete. Inkludér forventet og faktisk resultat.",
    "reportBugDescriptionPlaceholder": "Hvad skete der? Hvad forventede du?",
    "reportBugAddImage": "Tilføj billede",
    "reportBugRemoveImage": "Fjern billede",
    "reportBugPasteHint": "Tip: indsæt en billede fra udklipsholder når denne dialogen er åben.",
    "reportBugSend": "Send rapport",
    "reportBugSending": "Sender...",
    "reportBugSent": "Bugrapport sendt til Slack #bugs.",
    "reportBugSendFailed": "Kunne ikke sende bugrapport",
    "reportBugInvalidImage": "Kun billedefiler understøttes.",
    "reportBugImageTooLarge": "Bilden er for stor (max 8 MB).",
    "reportBugMissingContent": "Tilføj en beskrivelse eller et billede, før du sender.",
    "reportBugFileUnsupported": "Filupload understøttes kun på nettet."
  },
  "profile": {
    "title": "Profil",
    "loading": "Henter profil...",
    "loadFailed": "Kunne ikke hente profil.",
    "playerProvisioning": "Opretter din spillerprofil...",
    "displayNameLabel": "Vist navn",
    "displayNamePlaceholder": "Dit kaldenavn",
    "fullNameLabel": "Fulde navn",
    "fullNamePlaceholder": "Dit fulde navn",
    "nameLabel": "Navn",
    "namePlaceholder": "Angiv dit navn",
    "emailLabel": "E-mail",
    "emailPlaceholder": "navn@example.com",
    "genderLabel": "Køn",
    "genderPlaceholder": "mand, kvinde eller andet",
    "genderMale": "Mand",
    "genderFemale": "Kvinde",
    "genderNeutral": "Neutral",
    "handicapLabel": "Handicap",
    "handicapPlaceholder": "fx 12,4",
    "handicapDateLabel": "Handicapdato",
    "handicapDatePlaceholder": "ÅÅÅÅ-MM-DD",
    "golfIdLabel": "Golf-ID",
    "golfIdPlaceholder": "f.eks. 12-3456",
    "golfIdHelp": "Dit Golf-ID fra forbundet. Andre spillere kan finde dig med det, hvis du tillader det nedenfor.",
    "invalidGolfId": "Indtast et gyldigt Golf-ID (bogstaver, tal og bindestreger).",
    "golfIdTaken": "Det Golf-ID bruges allerede af en anden konto.",
    "searchVisibilityLabel": "Hvem kan finde mig",
    "searchVisibilityName": "Via navn",
    "searchVisibilityGolfId": "Kun via Golf-ID",
    "searchVisibilityNever": "Ingen",
    "searchVisibilityNameHelp": "Du vises i spillerlister og kan søges frem på navn.",
    "searchVisibilityGolfIdHelp": "Du skjules i spillerlister; kun den, der skriver dit præcise Golf-ID, kan finde dig.",
    "searchVisibilityNeverHelp": "Du vises aldrig i søgning eller spillerlister. Venner og deltagere i dine ture ser dig stadig.",
    "searchVisibilityGolfIdRequired": "Tilføj dit Golf-ID, før du vælger kun at kunne findes via Golf-ID.",
    "imageLabel": "Profilbillede",
    "uploadImage": "Indlæs billede op",
    "selectAvatar": "Vælg avatar",
    "removeAvatar": "Fjern avatar",
    "avatarPickerTitle": "Vælg en avatar",
    "avatarMore": "Flere",
    "avatarLoading": "Indlæser avatarer...",
    "close": "Luk",
    "save": "Gem",
    "saving": "Gemmer...",
    "saveSuccess": "Profil gemt.",
    "saveFailed": "Kunne ikke gemme profil.",
    "handicapRequired": "Angiv handicap når handicapdato er sat.",
    "handicapDateRequired": "Angiv handicapdato når handicap er sat.",
    "invalidHandicap": "Angiv en gyldig handicapværdi.",
    "invalidHandicapDate": "Angiv en gyldig handicapdato (ÅÅÅÅ-MM-DD).",
    "homeClubsLabel": "Hjemmeklubber",
    "homeClubsEmpty": "Ingen hjemmeklub valgt.",
    "homeClubsAdd": "Tilføj hjemmeklub",
    "homeClubsPrimary": "Primær",
    "homeClubsSetPrimary": "Sæt som primær",
    "homeClubsRemove": "Fjern",
    "homeClubsPickerTitle": "Vælg hjemmeklub",
    "homeClubsSearchPlaceholder": "Søg klub...",
    "homeClubsLoading": "Indlæser klubber...",
    "homeClubsNoResults": "Ingen klubber fundet.",
    "homeClubsUnknownLocation": "Ukendt sted",
    "homeClubsRefresh": "Opdater",
    "homeClubsLoadFailed": "Kunne ikke indlæse klubber.",
    "uploading": "Indlæser billede op...",
    "uploadSuccess": "Billede uploadet.",
    "uploadFailed": "Kunne ikke uploade billede.",
    "permissionDenied": "Adgang til fotobibliotek nægtet.",
    "passwordSectionLabel": "Adgangskode",
    "changePassword": "Skift adgangskode",
    "setPassword": "Opret adgangskode",
    "passwordSetHint": "Du loggede ind med Google. Opret en adgangskode for også at kunne logge ind med e-mail og adgangskode.",
    "currentPasswordLabel": "Nuværende adgangskode",
    "newPasswordLabel": "Ny adgangskode",
    "newPasswordPlaceholder": "Mindst {min} tegn",
    "repeatPasswordLabel": "Gentag ny adgangskode",
    "passwordMismatch": "Adgangskoderne er ikke ens.",
    "passwordTooShort": "Adgangskoden skal være mindst {min} tegn.",
    "currentPasswordRequired": "Indtast din nuværende adgangskode.",
    "currentPasswordInvalid": "Den nuværende adgangskode er forkert.",
    "passwordAccountLocked": "For mange forsøg. Prøv igen senere.",
    "passwordChangeFailed": "Adgangskoden kunne ikke ændres.",
    "passwordChangeTimeout": "Anmodningen fik timeout. Prøv igen.",
    "passwordChanged": "Adgangskoden er opdateret.",
    "passwordSaving": "Opdaterer adgangskode...",
    "deleteAccountSectionLabel": "Slet konto",
    "deleteAccountHint": "Fjerner dit login og din profil. Det kan ikke fortrydes.",
    "deleteAccount": "Slet min konto",
    "deleteAccountConfirmTitle": "Vil du slette din konto?",
    "deleteAccountConfirmBody": "Dit login, din profil, dit billede og dine indstillinger slettes permanent. Det kan ikke fortrydes.",
    "deleteAccountConfirmHistory": "Runder og tours, du har spillet, bliver stående på de andre spilleres scorekort, stadig med dit navn. At fjerne dem ville omskrive en andens runde.",
    "deleteAccountConfirm": "Slet konto",
    "deleteAccountCancel": "Annuller",
    "deleteAccountPending": "Sletter...",
    "deleteAccountFailed": "Kunne ikke slette kontoen. Prøv igen.",
    "enhancedInputSectionLabel": "Slagdetaljer",
    "enhancedInputHint": "Registrer fairwaytræf, putts og greens i regulation på dine egne scores. Ingen andre ser dem, og intet andet i runden ændres.",
    "enhancedInputToggleLabel": "Registrer slagdetaljer",
    "enhancedInputOn": "Til",
    "enhancedInputOff": "Fra",
    "shotTrackingSectionLabel": "Automatisk slaglængde",
    "shotTrackingHint": "Mål hvor langt du slår hvert slag, helt uden tryk. Telefonen lytter kun efter træflyden, mens du står stille, og bruger GPS til afstanden. Ingen lyd gemmes eller forlader telefonen — kun selve træføjeblikket. Fungerer sammen med uret, når du bærer et.",
    "shotTrackingToggleLabel": "Mål mine slag",
    "shotTrackingOn": "Til",
    "shotTrackingOff": "Fra",
    "shotTrackingAndroidOnly": "Telefonbaseret detektering virker i øjeblikket på Android. På andre enheder kan uret stadig markere dine slag.",
    "showDistanceSectionLabel": "Afstand til green",
    "showDistanceHint": "Vis din live afstand til midten af greenen ved siden af Par og Index på hulskærmen. Bruger din telefons GPS.",
    "showDistanceToggleLabel": "Vis afstand",
    "showDistanceOn": "Til",
    "showDistanceOff": "Fra",
    "coachTipsSectionLabel": "Tips",
    "coachTipsHint": "Tips peger på funktioner, mens du spiller. De vises, indtil du skjuler dem.",
    "coachTipsToggleLabel": "Vis tips",
    "coachTipsOn": "Til",
    "coachTipsOff": "Fra",
    "coachTipsReset": "Vis skjulte tips igen",
    "coachTipsResetting": "Gendanner tips...",
    "coachTipsSaveFailed": "Kunne ikke opdatere tips.",
    "distanceUnitSectionLabel": "Afstande",
    "distanceUnitHint": "Hvordan afstande vises i appen. Alt gemmes i meter, så valget ændrer kun det, du læser.",
    "distanceUnitMetric": "Meter og kilometer",
    "distanceUnitImperial": "Yards og miles",
    "shotTrackingDebugLink": "Fejlfinding slagmåling (udviklere)"
  },
  "statistics": {
    "title": "Min statistik",
    "tabGames": "Spil & toure",
    "tabScoring": "Score",
    "allTime": "Alle år",
    "loading": "Henter statistik...",
    "loadFailed": "Kunne ikke hente din statistik.",
    "noPlayer": "Der er endnu ingen spillerprofil til din konto.",
    "signedOut": "Log ind for at se din statistik.",
    "retry": "Prøv igen",
    "emptyTitle": "Ingen runder endnu",
    "emptyHint": "Spil og registrér en runde, så begynder din statistik at bygge sig op her.",
    "roundsPlayed": "Spillede runder",
    "tours": "Toure",
    "activeSuffix": "· {count} i gang",
    "gamesPlayed": "Spillede spil",
    "meritsEarned": "Optjente meritter",
    "vsLastSeason": "{delta} mod sidste sæson",
    "sameAsLastSeason": "Samme som sidste sæson",
    "activeTours": "Igangværende toure",
    "noActiveTours": "Ingen toure i gang lige nu.",
    "tourLeading": "af {players} spillere · fører",
    "tourBehind": "af {players} spillere · {merits} meritter efter",
    "trophyCabinet": "Pokalskab",
    "trophyCabinetNote": "Alle år, uanset valgt periode.",
    "tourWins": "Toursejre",
    "tourRunnerUps": "Andenpladser",
    "tourPodiums": "Podieplaceringer",
    "roundWins": "Rundesejre",
    "gamesPlayedAndWon": "Spil — spillet og vundet",
    "noGames": "Ingen spil spillet i perioden.",
    "gameWinsOfRounds": "{wins} af {rounds}",
    "unknownGame": "Spil",
    "recentRounds": "Seneste runder",
    "noRounds": "Ingen runder i perioden.",
    "roundScore": "{gross} · {toPar}",
    "positionOf": "{position} af {total}",
    "averageToPar": "Gns. mod par · pr. 18",
    "bestRound": "Bedste runde",
    "bestRoundAt": "Bedste runde · {course}, {date}",
    "playingHandicap": "Spillehandicap",
    "playingHandicapNote": "Spillehandicappet registreret på hver runde, ældst til nyest.",
    "handicapDown": "▼ {delta} i perioden",
    "handicapUp": "▲ {delta} i perioden",
    "formTitle": "Form — score mod par, seneste {count} runder",
    "average": "gns.",
    "formLegend": "Kortere er bedre. Tryk på en runde for at åbne scorekortet.",
    "scoreDistribution": "Score · {holes} huller",
    "noHoles": "Ingen registrerede huller i perioden.",
    "eagle": "Eagle",
    "birdie": "Birdie",
    "par": "Par",
    "bogey": "Bogey",
    "doublePlus": "Dobbelt+",
    "countWithShare": "{count} · {share} %",
    "pickupsExcluded": "{count} samlet-op-huller tælles ikke med.",
    "averageOverPar": "Gennemsnit over par",
    "parN": "Par {par}",
    "frontNine": "Ud 9",
    "backNine": "Ind 9",
    "shotDetail": "Slagdetaljer",
    "fairwaysHit": "Fairwaytræf",
    "greensInRegulation": "Greens i regulation",
    "puttsPerRound": "Putts pr. runde",
    "puttsPerGir": "Putts pr. ramt green",
    "shotDetailOfHoles": "{part} af {total} huller",
    "shotDetailPuttsHint": "{perHole} pr. hul over {holes} huller",
    "recordsAndStreaks": "Rekorder & serier",
    "mostBirdies": "Flest birdies på en runde",
    "longestStreak": "Længste serie med par eller bedre",
    "holesCount": "{count} huller",
    "bestComeback": "Bedste ind-ni mod ud-ni",
    "holeInOnes": "Hole in one",
    "nemesisHole": "Nemesis-hul",
    "nemesisValue": "#{hole} {course}",
    "nemesisHint": "{average} i gns. over {plays} spil"
  },
  "teamDraw": {
    "title": "Holdlodtrækning"
  },
  "serviceStatus": {
    "buttonLabel": "Tjenestestatus",
    "alert": "!",
    "title": "Tjenester mangler",
    "allOk": "Alle tjenester er i gang.",
    "warningsFound": "Advarsler eller fejl fundet i logs.",
    "unknownTimestamp": "Ukendt tidspunkt",
    "unknownService": "Ukendt tjeneste",
    "unknownBody": "Ingen logtekst",
    "continueMissing": "Fortsæt (mangler: {missing})",
    "close": "Luk",
    "checkedAt": "Kontrolleret: {time}",
    "bffName": "backend-for-frontend-service",
    "host": "Vært: {host}",
    "httpCode": "Returkode: {code}",
    "unknownHost": "Ukendt vært",
    "envVar": "Miljøvariabel: {envVar}",
    "unknownEnvVar": "Miljøvariabel: ukendt",
    "ipAddress": "Opslået IP: {ip}"
  },
  "debug": {
    "button": "Debug",
    "buttonLabel": "Debug-information",
    "title": "Debug-info",
    "userLabel": "Bruger",
    "userIdLabel": "Bruger-ID",
    "playerIdLabel": "Spiller-ID",
    "roundLabel": "Runde-ID",
    "roundNameLabel": "Rundenavn",
    "tourLabel": "Tour-ID",
    "tourNameLabel": "Tournavn",
    "holeViewTraceLabel": "TraceId hulvy",
    "holeScoreTraceLabel": "TraceId hulscore",
    "traceNone": "Ingen",
    "copyIdsLabel": "Kopiér debug-ID'er",
    "copyIdLabel": "Kopiér {label}",
    "loading": "Henter navn...",
    "unknown": "Ukendt",
    "close": "Luk",
    "disable": "Deaktivér debug",
    "resetCoachMarks": "Nulstil coach marks",
    "resetCoachMarksRunning": "Nulstiller coach marks...",
    "resetCoachMarksSuccess": "Coach marks nulstillet for brugeren.",
    "resetCoachMarksError": "Kunne ikke nulstille coach marks.",
    "coachMarksTitle": "Coach marks",
    "coachMarksEmpty": "Ingen coach marks indlæsedes.",
    "coachMarkLabel": "Coach mark: {key}",
    "deeplinkTitle": "Deep link-debug",
    "deeplinkPlatform": "Platform",
    "deeplinkLatest": "Seneste URL",
    "deeplinkEmpty": "Ingen deep link modtaget endnu.",
    "coachMarkDismissed": "skjult"
  },
  "welcome": {
    "title": "Velkommen",
    "body": "Vælg hvordan du vil starte: opret en enkelt runde, start en ny tour eller åbn dine eksisterende tours og ikke-afsluttede runder.",
    "startSingleRound": "Start enkelt runde",
    "startQuickRound": "Lynrunde",
    "startTour": "Opret tour",
    "myTours": "Mine tours og runder",
    "myToursOpenSummary": "Åbne tours: {tours} · Enkelt runder: {singleRounds}",
    "myToursNav": "Mine runder"
  },
  "quickRound": {
    "trackingTitle": "Registrer"
  },
  "friendInvite": {
    "title": "Bliv venner",
    "showTitle": "Lad dem scanne denne",
    "showSubtitle": "Ret den anden telefons kamera mod koden",
    "expiryNote": "Koden fornyes et par gange i minuttet",
    "shareAction": "Del link",
    "shareError": "Kunne ikke dele linket.",
    "loadError": "Kunne ikke oprette en invitationskode.",
    "regenerate": "Ny kode",
    "close": "Luk",
    "previewTitle": "{name} vil gerne forbindes",
    "previewUnknown": "Nogen vil gerne forbindes på Goffy",
    "signInToConnect": "Log ind for at forbinde",
    "connecting": "Forbinder...",
    "connected": "Du og {name} er nu venner",
    "alreadyConnected": "Du er allerede venner med {name}",
    "seeFriends": "Se mine venner",
    "errorExpired": "Denne kode er udløbet. Bed om en ny.",
    "errorInvalid": "Dette invitationslink er ikke gyldigt.",
    "errorSelf": "Det er din egen invitationskode.",
    "errorPlayerRequired": "Denne konto kan endnu ikke tilføjes som ven.",
    "errorUnauthenticated": "Log ind for at forbinde.",
    "errorFailed": "Kunne ikke forbinde. Prøv igen."
  },
  "friends": {
    "connectViaQr": "Forbind via QR",
    "title": "Venner",
    "loading": "Indlæser venner...",
    "empty": "Ingen venner tilføjet endnu.",
    "myFriends": "Mine venner",
    "linked": "Ven",
    "addLinked": "Tilføj en ven",
    "searchPlaceholder": "Søg på navn eller Golf-ID",
    "add": "Tilføj",
    "remove": "Fjern",
    "editNickname": "Rediger kaldenavn",
    "cancel": "Annuller",
    "nicknamePlaceholder": "Kaldenavn (valgfrit)",
    "saveNickname": "Gem kaldenavn",
    "actionFailed": "Kunne ikke opdatere venner.",
    "findPlayersPlaceholder": "Find spillere...",
    "filterAll": "Alle",
    "filterLinked": "Venner",
    "filterGuests": "Mine gæster",
    "guest": "Gæst",
    "countAll": "Spillere {count}",
    "countLinked": "Venner {count}",
    "countGuests": "Mine gæster {count}",
    "guestsEmpty": "Ingen gæstespillere tilføjet endnu.",
    "guestsFailed": "Kunne ikke indlæse dine gæstespillere.",
    "noMatches": "Ingen venner matcher din søgning.",
    "searchHint": "Skriv et navn, eller et præcist Golf-ID for at finde spillere, der kun kan findes sådan.",
    "searchNoResults": "Ingen spillere matcher din søgning.",
    "searchFailed": "Kunne ikke søge efter spillere.",
    "searching": "Søger..."
  },
  "coachMarks": {
    "tournamentsCreateTitle": "Opret din første turnering",
    "tournamentsCreateBody": "Brug knappen for at oprette en ny turnering og gå videre til rundeopsætning.",
    "profileImageActionsTitle": "Vælg profilbillede",
    "profileImageActionsBody": "Indlæs et billede op, eller vælg en avatar, som vises sammen med dit navn.",
    "holeScoreTitle": "Tips til score-rækken",
    "holeScoreBody": "Tryk på Score for at åbne scoreindtastning og registrere hazard- eller mystery-resultater.",
    "gotIt": "Jeg forstår",
    "hideForever": "Vis ikke dette tip igen",
    "disableAll": "Slå alle tips fra"
  },
  "courseConfig": {
    "title": "Konfigurer bane",
    "manageSelectorLabel": "Bane at administrere",
    "manageCreateNew": "Ny bane",
    "manageSelectedCourse": "Valgt bane",
    "manageNoCourses": "Ingen baner at administrere endnu",
    "manageSearchPlaceholder": "Søg bane, klub eller by",
    "manageNoMatches": "Ingen bane matcher \"{query}\"",
    "clubLabel": "Klub",
    "clubPlaceholder": "Klubnavn",
    "cityLabel": "By",
    "cityPlaceholder": "Bynavn",
    "coordinatesLabel": "Koordinater",
    "courseLabel": "Bane",
    "coursePlaceholder": "Banenavn",
    "scanButton": "AI-scan scorekort",
    "cameraCapture": "Tag billede",
    "cameraCancel": "Annuller",
    "cameraUnavailable": "Kunne ikke åbne kameraet. Kontrollér kameratilladelser og prøv igen.",
    "scanRunning": "AI'en læser scorekortet…",
    "scanThinkingHint": "Analyserer billedet — det kan tage op til et minut.",
    "scanSuccess": "Scorekortet er læst — kontrollér værdierne.",
    "scanFailed": "Kunne ikke læse scorekortet. Indtast hullerne manuelt.",
    "scanNotConfigured": "Scanning af scorekort er ikke konfigureret på serveren endnu.",
    "scanPermissionDenied": "Kameratilladelse kræves for at scanne.",
    "holeHeader": "Hul",
    "parHeader": "Par",
    "strokeIndexHeader": "Index",
    "teesTitle": "Tee-opsætning",
    "addTeeButton": "Tilføj tee",
    "teeLabel": "Tee {index}",
    "removeTeeButton": "Fjern",
    "teeNameLabel": "Tee-navn",
    "teeNamePlaceholder": "Gul",
    "teeGenderLabel": "Køn",
    "genderMale": "Mand",
    "genderFemale": "Kvinde",
    "genderUnisex": "Unisex",
    "teeParLabel": "Tee par",
    "makeOfficialLabel": "Tilføj til officielle baner",
    "makeOfficialHint": "Officielle baner deles med alle. Lad være med at markere for at holde banen privat for dig.",
    "disableCourseLabel": "Deaktivér denne bane",
    "disableCourseHint": "En deaktiveret bane skjules fra alle banevælgere, men slettes ikke. Fjern markeringen og gem for at gendanne den.",
    "visibilityLabel": "Synlighed",
    "visibility_official": "Officiel",
    "visibility_private": "Privat",
    "visibility_pending": "Afventer",
    "visibilityHint_official": "Deles med alle.",
    "visibilityHint_private": "Kun synlig for dig og spillere, du deler den med.",
    "visibilityHint_pending": "Indsendt til godkendelse; kun synlig for dig, indtil den godkendes.",
    "courseRatingLabel": "Course rating",
    "slopeRatingLabel": "Slope rating",
    "cancelButton": "Annuller",
    "saveButton": "Gem bane",
    "saving": "Gemmer bane...",
    "waitingConnection": "Venter på websocket-forbindelse...",
    "saveSuccess": "Bane gemt {id}",
    "saveRejected": "Det lykkedes ikke at gemme banen.",
    "clubRequired": "Klubnavn skal angives.",
    "courseRequired": "Banenavn skal angives.",
    "invalidPar": "Alle huller skal have en parværdi.",
    "invalidStrokeIndex": "Alle huller skal have et index.",
    "teesRequired": "Tilføj mindst én tee.",
    "teeNameRequired": "Alle tees skal have et navn.",
    "teeGenderRequired": "Alle tees skal have et køn.",
    "invalidCourseRating": "Alle tees skal have en gyldig course rating.",
    "invalidSlopeRating": "Alle tees skal have en gyldig slope rating.",
    "invalidTeePar": "Alle tees skal have en gyldig parværdi.",
    "fixBeforeSave": "Ret følgende, før du gemmer:",
    "saveWithErrorsLabel": "Gem alligevel (med fejl)",
    "parSumMismatch": "Summen af alle hullers par ({sum}) skal være lig med Tee par ({teePar}).",
    "strokeIndexDuplicate": "Index {value} bruges af mere end ét hul (hul {holes}). Hvert index må kun bruges én gang.",
    "strokeIndexRange": "Index skal være et tal mellem 1 og 18 (hul {hole} har {value}).",
    "lengthHeader": "Længde (m)",
    "invalidLength": "Hullængden skal være et positivt tal eller stå tom, hvis den er ukendt.",
    "osmButton": "Importer data fra OpenStreetMap",
    "osmSearching": "Søger…",
    "osmImporting": "Importerer huller…",
    "osmUnnamed": "Unavngiven bane",
    "osmSuccess": "Importerede {count} huller — kontrollér værdierne.",
    "osmPartial": "Importeret. {count} index kunne ikke læses i OpenStreetMap, så de blev efterladt uændret.",
    "osmNoCourses": "Fandt ingen bane i OpenStreetMap med brugbare data.",
    "osmNoHoles": "Den bane har ingen huller kortlagt i OpenStreetMap.",
    "osmNoLocation": "Kunne ikke fastslå en position at søge ud fra.",
    "osmFailed": "Opslaget i OpenStreetMap mislykkedes. Prøv igen.",
    "osmAttribution": "Huldata © OpenStreetMap-bidragydere (ODbL)",
    "osmSearch": "Søg",
    "osmModeNearby": "I nærheden",
    "osmModeName": "På navn",
    "osmNamePlaceholder": "Bane eller klub",
    "osmNameTooShort": "Indtast mindst tre tegn for at søge på navn.",
    "osmChooseData": "Vælg hvad der skal importeres:",
    "osmCategoryHoles": "Huloplysninger",
    "osmCategoryHolesDetail": "{count} huller med par og index",
    "osmCategoryTees": "Tees",
    "osmCategoryTeesDetail": "{count} navngivne tees",
    "osmCategoryGps": "GPS",
    "osmCategoryGpsDetail": "{greens} greenpositioner, {tees} teepositioner",
    "osmCategoryTerrain": "Bunkers, vand og fairways",
    "osmCategoryTerrainDetail": "{count} indtegnede konturer — bruges i stedet for dem, der findes i satellitbilleder",
    "osmImportAction": "Importer",
    "osmBack": "Tilbage",
    "osmImportSummary": "Importerede {holes} huller, {tees} teesæt og {positions} positioner — kontroller værdierne.",
    "osmDistanceMeta": "{distance} m væk",
    "osmNothingToImport": "OpenStreetMap har intet om den bane — ikke engang en position.",
    "osmCategoryPosition": "Banens position",
    "osmCategoryPositionDetail": "Hvor banen ligger. Nok i sig selv til at analysere satellitbilleder for greens, bunkers og vand.",
    "osmImportSummaryWithPosition": "Importerede {holes} huller, {tees} teesæt og {positions} positioner samt banens position — satellitbilleder analyseres om lidt.",
    "osmImportSummaryPositionOnly": "Banens position er sat. OpenStreetMap har ingen huller, tees eller greens for banen, så satellitbilleder analyseres for at finde dem.",
    "osmCategoryGpsApproximate": "{greens} greenpositioner, {tees} teepositioner — hentet fra hullernes forløb, med få meters nøjagtighed, én pr. hul",
    "osmLoadingCounts": "Tjekker hvad OpenStreetMap har for denne bane…",
    "osmCoordinateLine": "{origin} {originCoords} · OSM {osmCoords} · {distance}",
    "osmOriginStored": "Gemt",
    "osmOriginDevice": "Enhed",
    "osmOriginMap": "Valgt",
    "osmPositionUseOsm": "OSM-placering ({distance} væk)",
    "osmPositionUsePicked": "Min valgte placering",
    "osmPickLocation": "Vælg placering på kort",
    "osmUsePickedAnyway": "Ingen af disse — brug den valgte placering alligevel",
    "osmMapUseMyLocation": "Brug min nuværende placering",
    "osmMapLocateDenied": "Der blev ikke givet adgang til placering.",
    "osmMapLocateFailed": "Kunne ikke bestemme enhedens placering.",
    "osmMapGotoPlaceholder": "Breddegrad, længdegrad",
    "osmMapGotoInvalid": "Kunne ikke læse det som en breddegrad og længdegrad. Prøv \"56.6776, 12.8578\".",
    "osmMapGo": "Gå til",
    "osmMapConfirm": "Søg herfra",
    "osmMapUseAsPosition": "OSM har intet her — brug denne præcise placering",
    "osmMapCancel": "Annuller",
    "osmMapHint": "Træk kortet, så trådkorset ligger over banen, og bekræft derefter.",
    "osmMapPlacePlaceholder": "Søg efter et sted",
    "osmMapPlaceTooShort": "Skriv mindst 3 tegn.",
    "osmMapPlaceFailed": "Stedsøgningen mislykkedes.",
    "osmMapPlaceNoResults": "Ingen steder fundet.",
    "osmDebugToggle": "Debug · {count} loggede",
    "osmDebugEmpty": "Intet logget endnu.",
    "osmDebugCurlHint": "Kommandoerne bruger $GOFFY_TOKEN — eksportér din bearer-token, før du kører dem.",
    "osmDebugCopy": "Kopiér kommando",
    "osmHolesUnnumbered": "OpenStreetMap har {drawn} hulmarkering(er) for banen, men {unnumbered} af dem mangler hulnummer — importen skal bruge et nummereret hul (OSM-tagget ref=1…18) for at vide, hvilket hul der er hvilket.",
    "osmTerrainNoHoles": "Bunkers, vand og fairways blev ikke importeret: OpenStreetMap har ingen nummererede hulmarkeringer for banen at knytte dem til.",
    "teeColorLabel": "Teefarve",
    "teeColorPlaceholder": "gul"
  },
  "tournaments": {
    "title": "Turneringer",
    "loading": "Indlæser turneringer...",
    "menuLabel": "Turneringval",
    "showFinished": "Vis afsluttede",
    "hideFinished": "Skjul afsluttede",
    "showFinishedSingleRounds": "Vis afsluttede enkelt runder",
    "hideFinishedSingleRounds": "Skjul afsluttede enkelt runder",
    "statusContinue": "Fortsæt",
    "statusPause": "Pause",
    "statusArchive": "Arkiver",
    "statusSleep": "Dvale",
    "statusCancel": "Annuller",
    "statusDelete": "Slet",
    "deleteConfirmTitle": "Slet turneringen?",
    "deleteConfirmMessage": "\"{name}\" fjernes fra dine turneringer. Dette kan ikke fortrydes.",
    "deleteConfirmCta": "Slet",
    "deleteConfirmKeep": "Behold",
    "deleteRoundConfirmTitle": "Slet runden?",
    "deleteRoundConfirmMessage": "\"{name}\" fjernes fra dine runder. Dette kan ikke fortrydes.",
    "statusUpdateSent": "Opdaterer status til {status}...",
    "statusUpdateAck": "Turneringstatus opdateret.",
    "statusUpdateFailed": "Kunne ikke opdatere turneringsstatussen.",
    "statusUpdateQueued": "Venter på websocket...",
    "archiveTitle": "Turnering opdateret",
    "archiveMessage": "Turneringstatus blev opdateret.",
    "loadError": "Det lykkedes ikke at hente turneringer.",
    "empty": "Ingen turnering fundet. Opret en ny.",
    "defaultName": "Ny turnering",
    "namePlaceholder": "Turnering navn",
    "createTitle": "Ny tour",
    "nameLabel": "Navn",
    "nameRequired": "Giv touren et navn først.",
    "createConfirm": "Opret",
    "createCancel": "Annuller",
    "statusFinish": "Afslut tour",
    "statusFinishConfirm": "Afslut denne tour? Slutstillingen låses, og tourpointene uddeles. Du kan genåbne den senere.",
    "statusReopen": "Genåbn tour",
    "statusFinishRound": "Afslut runden",
    "statusFinishRoundConfirm": "Afslut denne runde? Resultaterne låses og gøres op.",
    "roundMenuLabel": "Rundevalg",
    "creating": "Opretter turnering...",
    "createCta": "Ny turnering",
    "singleRoundCta": "Enkelt runde",
    "createdNotice": "Ny turnering er oprettet. Vælg turnering fra listen.",
    "createdWithId": "Turnering oprettet: {id}",
    "createFailed": "Kunne ikke oprette turnering lige nu. Prøv igen.",
    "membersTitle": "Turneringmedlemmar",
    "membersLoading": "Indlæser spillere...",
    "membersCount": "Valgte: {selected}/{max}",
    "membersLoadError": "Det lykkedes ikke at indlæse platformsspillere.",
    "playerProvisioning": "Opretter din spillerprofil...",
    "playerProvisioningRetry": "Spillerprofilen er forsinket. Prøv igen.",
    "playerProvisioningTimeout": "Tiden løb ud for at oprette spillerprofilen. Prøv igen.",
    "playerProvisioningActionRetry": "Prøv igen",
    "playerProvisioningBlocked": "Vent til din spillerprofil er klar, før du opretter en turnering.",
    "creatorMemberLocked": "Din spillere er altid med i turneringen og kan ikke fjernes.",
    "creatorMemberRequired": "Din spillerprofil skal være med, før du kan oprette en turnering.",
    "shareCta": "Dela",
    "shareTitle": "Del {name}",
    "shareSubtitle": "Alle med linket kan se live-resultater for turneringen.",
    "shareAction": "Del link",
    "shareClose": "Luk",
    "shareLoadError": "Kunne ikke oprette et invitationslink for denne turnering.",
    "shareSendError": "Det lykkedes ikke at dele invitationlinket på denne enheden.",
    "shareCopied": "Invitationslink kopieret.",
    "openButton": "Åbn",
    "newRoundCta": "Tilføj runde",
    "roundsTitle": "Runder",
    "unfinishedRoundsTitle": "Ikke-afsluttede runder",
    "hiddenToursSingleRoundsTitle": "Enkelt runder",
    "roundsLoading": "Indlæser runder...",
    "roundsEmpty": "Ingen runder fundet.",
    "roundsLoadError": "Det lykkedes ikke at indlæse runder.",
    "myToursAndRoundsSummary": "Tours: {tours} · Ikke-afsluttede runder: {rounds}",
    "roundFallbackName": "Runde",
    "roundOpen": "Åbn",
    "roundStart": "Start",
    "roundUpdate": "Opdater",
    "roundSettings": "Rundeindstillinger",
    "tourSettings": "Tour-indstillinger",
    "roundResults": "Resultater",
    "roundStatus": "Status: {status}",
    "roundStatusWithDate": "Status: {status} · {date}",
    "editCta": "Rediger",
    "gamesTitle": "Spil",
    "gamesCount": "{count} spil",
    "gamesLoading": "Indlæser spil...",
    "gamesEmpty": "Ingen spil valda.",
    "gamesLoadError": "Det lykkedes ikke at indlæse spil.",
    "groupsLoading": "Indlæser grupper...",
    "groupsLoadError": "Det lykkedes ikke at indlæse grupper.",
    "gameFallbackName": "Spil",
    "gameTypeUnknown": "Øvrigt",
    "gameTypeLabel": "Type:",
    "gameTypeMissing": "Type: Ukendt",
    "gameWeightLabel": "Vægt",
    "gameDetailsTitle": "Spildetaljer",
    "gameDetailsEmpty": "Ingen beskrivelse tilgængelig.",
    "gameCalculationLabel": "Beregning:",
    "addGame": "Tilføj spil",
    "addGameTitle": "Tilføj spil",
    "addGameEmpty": "Alle spil er allerede tilføjet.",
    "noTours": "Ingen turnering fundet."
  },
  "tourEdit": {
    "playersTitle": "Spillere",
    "addPlayer": "Tilføj spillere",
    "removePlayer": "Fjern",
    "playerCreateTemporary": "Opret midlertidig",
    "playerTemporarySelected": "Midlertidig valgt",
    "playerSearchPlaceholder": "Søg spillere",
    "playerCurrentUserFallback": "Du",
    "playerConfirmSelectOrTemporary": "Vælg en eksisterende spiller, eller markér som midlertidig, før du bekræfter.",
    "playerConfirmEmpty": "Angiv et spillernavn, før du bekræfter.",
    "playerConfirmA11y": "Bekræft spillerrække",
    "playerCancelA11y": "Annuller spillerrække",
    "playerTemporaryToggleA11y": "Skift midlertidig spiller",
    "playerInviteTooltip": "Inviter",
    "playerInviteA11y": "Inviter {name}",
    "playerInviteTitle": "Inviter {name}",
    "playerInviteSubtitle": "Del dette link med {name} for at deltage i touren.",
    "playerInviteLoadError": "Kunne ikke oprette et invitationslink for denne spiller.",
    "playerInviteShareError": "Det lykkedes ikke at dele invitationslinket.",
    "playerInviteCopied": "Invitationslink kopieret.",
    "title": "Turnering redigering",
    "breadcrumbTitle": "Turnering - redigering",
    "subtitle": "Webversion",
    "tourIdLabel": "Tour-ID",
    "tourIdMissing": "Tour-ID mangler.",
    "webOnlyNote": "Denne side findes kun på nettet.",
    "nameLabel": "Turnering-navn",
    "namePlaceholder": "Angiv turneringnavn",
    "saveCta": "Gem",
    "saving": "Gemmer...",
    "saveSent": "Gemmer turnering...",
    "saveQueued": "Venter på websocket...",
    "saveAck": "Turnering opdateret.",
    "saveFailed": "Det lykkedes ikke at opdatere turnering.",
    "saveAll": "Gem alle",
    "saveAllSent": "Gemmer alle indstillinger...",
    "loading": "Indlæser turnering...",
    "loadError": "Det lykkedes ikke at indlæse turnering.",
    "nameRequired": "Angiv et turneringnavn.",
    "addRound": "Tilføj runde",
    "roundNameLabel": "Rundenavn",
    "roundDateLabel": "Spildatum",
    "roundDateUnset": "Vælg datum",
    "roundDatePicker": "Åbn kalender",
    "roundDatePickerTitle": "Vælg datum",
    "roundDatePickerToday": "I dag",
    "roundCreate": "Opret runde",
    "roundCreateSaving": "Opretter...",
    "roundCreateFailed": "Det lykkedes ikke at oprette runden.",
    "roundCreateNoPlayers": "Ingen spillere fundet for turneringen.",
    "roundCreatePlayerLoading": "Indlæser spillere...",
    "addImage": "Tilføj billede",
    "uploadingImage": "Indlæser billede op...",
    "imageUploadFailed": "Det lykkedes ikke at indlæse billedet.",
    "imagePermissionDenied": "Goffy skal have adgang til dine billeder for at angive et tourbillede.",
    "imageUploadSuccess": "Turneringsbilledet opdateret.",
    "roundPlayersTitle": "Rundspillere",
    "roundPlayersLoading": "Indlæser rundespillere...",
    "roundPlayersEmpty": "Ingen spillere i runden endnu.",
    "memberRemoving": "Fjerner spillere fra turneringen...",
    "memberRemoveSent": "Fjerner spillere fra turneringen...",
    "memberRemoved": "Spilleren blev fjernet fra turneringen.",
    "memberRemoveRejected": "Det lykkedes ikke at fjerne spilleren fra turneringen.",
    "memberRemoveTimeout": "Tidsfristen for fjernelse af turneringspillere blev overskredet.",
    "roundMemberRemoving": "Fjerner spillere fra runden...",
    "roundMemberRemoveSent": "Fjerner spillere fra runden...",
    "roundMemberRemoved": "Spilleren blev fjernet fra runden.",
    "roundMemberRemoveRejected": "Det lykkedes ikke at fjerne spilleren fra runden.",
    "roundMemberRemoveTimeout": "Tidsfristen for fjernelse af rundespillere blev overskredet.",
    "removeRound": "Fjern runde",
    "roundRemoving": "Fjerner runde...",
    "roundRemoveSent": "Fjerner runde...",
    "roundRemoved": "Runden blev fjernet.",
    "roundRemoveRejected": "Det lykkedes ikke at fjerne runden.",
    "roundRemoveTimeout": "Tidsfristen for fjernelse af runde blev overskredet.",
    "roundRemoveBlockedScores": "Runden har registrerede scorer",
    "roundRemoveA11y": "Fjern runde",
    "roundPlayerRemoveBlockedScores": "Har registrerede scorer",
    "roundPlayerRemoveBlockedLastPlayer": "Sidste spiller i runden",
    "roundPlayerRemoveA11y": "Fjern spillere fra runden",
    "roundPlayerRemoveDisabledA11y": "Spilleren kan ikke fjernes fra runden",
    "roundAddPlayer": "Tilføj spillere",
    "roundAddPlayerPlaceholder": "Vælg turneringmedlem",
    "roundAddPlayerNoCandidates": "Ingen tilgængelige turneringsmedlemmer at tilføje.",
    "roundAddPlayerStatusBlocked": "Rundstatus tillader ikke at spillere tilføjes.",
    "cancelRound": "Annuller",
    "done": "Klar",
    "playerSearchNoResults": "Ingen spillere fundet.",
    "playerAlreadyInTour": "Spilleren findes allerede i turneringen",
    "backToTours": "Til turneringer",
    "tournamentGamesTitle": "Turneringsspil",
    "tournamentGamesEmpty": "Ingen spil valgt på turneringsniveau.",
    "tournamentAddGame": "Tilføj turneringsspil",
    "tournamentRemoveGame": "Fjern",
    "tournamentManagedLabel": "Styret af turneringen",
    "gameDetailsPanelTitle": "Spildetaljer",
    "gameDetailsEmptyState": "Vælg et spil for at se detaljer.",
    "gameDetailsScopeLabel": "Omfang:",
    "gameDetailsTypeLabel": "Type:",
    "gameScopeLibrary": "Bibliotek",
    "gameScopeTournament": "Turnering",
    "gameScopeRoundLocal": "Kun denne runde"
  },
  "auth": {
    "loginTitle": "Log ind",
    "loginCardTitle": "Velkommen tilbage",
    "loginCta": "Login",
    "loggingIn": "Logger ind...",
    "loginSubtitle": "Log ind",
    "loginHint": "Du sendes til Keycloak for at logge ind.",
    "debugLabel": "Logget ind",
    "debugNone": "Ingen",
    "callbackLoading": "Gennemfører login...",
    "callbackReady": "Venter på svar fra Keycloak",
    "continueWithGoogle": "Fortsæt med Google",
    "orDivider": "eller"
  },
  "login": {
    "userNotFound": "Din bruger findes ikke længere. Log ind igen."
  },
  "start": {
    "title": "Velkommen til Goffy",
    "subtitle": "Indtast en invitationskode, hvis du har en, eller fortsæt med en ny eller eksisterende konto.",
    "roundCodeLabel": "Invitationskode",
    "roundCodePlaceholder": "Indtast invitationskode",
    "roundCodeRequired": "Indtast en invitationskode for at fortsætte.",
    "roundCodeInvalid": "Den invitationskode blev ikke fundet.",
    "roundCodeLookupFailed": "Invitationskoden kunne ikke åbnes. Prøv igen.",
    "joinWithCodeCta": "Deltag med kode",
    "scanQrCta": "Scan QR-kode",
    "qrScanTitle": "Scan QR-kode til invitation",
    "qrScanSubtitle": "Ret kameraet mod QR-koden fra invitationen til touren eller runden.",
    "qrScanCancelCta": "Annuller",
    "qrScanGrantCta": "Tillad kameraet",
    "qrScanPermissionPrompt": "Goffy skal bruge kameraet for at læse QR-koden til invitationen.",
    "qrScanPermissionDenied": "Adgang til kameraet blev nægtet, så QR-koden kan ikke læses.",
    "qrScanPermissionBlocked": "Adgang til kameraet er blokeret. Tillad kameraet for Goffy i indstillingerne for din enhed eller browser, og prøv igen.",
    "qrScanUnrecognized": "Den QR-kode er ikke en invitation fra Goffy.",
    "qrScanFriendInvite": "Det er en venneinvitation. Log ind først, og scan den så igen.",
    "resumeClaimTitle": "Fortsæt som {name}",
    "resumeClaimBody": "Du fører stadig scores i {tour} på denne enhed. Ingen login nødvendig.",
    "resumeClaimCta": "Fortsæt med at føre scores",
    "resumeClaimLeaderboardCta": "Åbn tourens leaderboard",
    "resumeClaimFallbackName": "din spiller",
    "resumeClaimFallbackTour": "denne tour",
    "signUpCta": "Opret konto",
    "logInCta": "Log ind",
    "emailLabel": "E-mail",
    "emailPlaceholder": "dig@eksempel.dk",
    "passwordLabel": "Adgangskode",
    "passwordPlaceholder": "Indtast adgangskode",
    "orDivider": "eller",
    "googleCta": "Fortsæt med Google",
    "forgotPasswordCta": "Glemt adgangskode?",
    "credentialsRequired": "Indtast din e-mail og adgangskode.",
    "loginFailed": "Forkert e-mail eller adgangskode."
  },
  "register": {
    "title": "Opret konto",
    "cardTitle": "Opret din konto",
    "usernameLabel": "Brugernavn",
    "usernamePlaceholder": "ditnavn",
    "displayNameLabel": "Vist navn",
    "displayNamePlaceholder": "Dit kaldenavn",
    "emailLabel": "E-post",
    "emailPlaceholder": "navn@example.com",
    "passwordLabel": "Adgangskode",
    "passwordPlaceholder": "Mindst 6 tegn",
    "creating": "Opretter...",
    "createCta": "Opret konto",
    "connectionLabel": "BFF-forbindelse: {status}",
    "connectionUp": "aktiv",
    "connectionDown": "frakoblet",
    "backToLogin": "Tilbage til startsiden",
    "statusQueued": "Sender anmodning...",
    "statusSuccess": "Konto oprettet! Log ind med din e-post og adgangskode.",
    "validationMissing": "Angiv e-mail, vist navn og adgangskode.",
    "validationPasswordTooShort": "Adgangskoden skal være mindst {min} tegn.",
    "connectionMissing": "Ingen forbindelse til BFF. Prøv igen.",
    "createTimeout": "Opret-forespørgslen tog for lang tid. Prøv igen.",
    "userExists": "En bruger med den e-mail findes allerede.",
    "createFailed": "Kunne ikke oprette bruger.",
    "openTermsCta": "Tjenestevilkår",
    "openPrivacyCta": "Privatlivspolitik",
    "claimAdoptNotice": "Du opretter en konto for {name}. Dine hidtidige scores bliver bevaret.",
    "claimProofInvalid": "Din spiller kunne ikke bekræftes. Åbn invitationslinket og gør krav på din spiller igen.",
    "statusReconnecting": "Forbindelsen blev afbrudt — vi færdiggør din registrering...",
    "termsNotice": "Ved at oprette en konto accepterer du tjenestens vilkår og privatlivspolitik.",
    "loginInsteadCta": "Log ind i stedet",
    "emailSuggestion": "Mente du {email}?",
    "emailSuggestionApply": "Brug den adresse",
    "emailSuggestionDismiss": "Behold det jeg skrev"
  },
  "home": {
    "addPlayers": "+ Tilføj spillere",
    "maxPlayers": "Max 8 spillere",
    "namePlaceholder": "Angiv navn",
    "primaryCta": "Vælg spil",
    "saveError": "Det lykkedes ikke at gemme spillere.",
    "saving": "Gemmer...",
    "scpPlaceholder": "SHCP",
    "scpRequired": "Angiv spille-hcp for alle spillere.",
    "title": "Tilføj spillere",
    "playerLabel": "Spillere {index}",
    "validationRequired": "Angiv mindst én spiller."
  },
  "selectGames": {
    "title": "Vælg spil",
    "waiting": "Venter på turnering-ID...",
    "tourIdLabel": "Aktuelt tour-ID",
    "tourLabel": "Tour",
    "roundLabel": "Runde",
    "playersLabel": "Spillere: {count}",
    "gamesLabel": "Spiltyper: {count}",
    "missing": "mangler",
    "hint": "Hold skærmen åben, indtil turneringen er klar.",
    "quickRoundPreparing": "Klargør din lynrunde...",
    "quickRoundError": "Kunne ikke starte runden.",
    "gameListTitle": "Vælg et spil",
    "recommendedBadge": "Anbefalet",
    "gameInfo": "Info",
    "gameDescription": "Beskrivelse",
    "infoIcon": "i",
    "infoVideoTitle": "Mystery-spil info",
    "infoVideoTitleByGame": "{name} spilinfo",
    "gameNameFallback": "Spil",
    "copyFromRound": "Kopiér fra en tidligere runde",
    "copyFromRoundTitle": "Kopiér fra en tidligere runde",
    "copyFromRoundSubtitle": "Henter spil og vægte. Du kan ændre det hele bagefter.",
    "copyFromRoundEmpty": "Ingen af dine tidligere runder har spil at kopiere endnu.",
    "copyFromRoundClose": "Luk",
    "infoDescriptionTitle": "Beskrivelse",
    "infoDescriptionEmpty": "Ingen beskrivelse tilgængelig.",
    "infoDescriptionExtra": "Dette spil scores hul for hul og påvirker rundens samlede resultat ud fra sin vægt.",
    "infoGameTypeTitle": "Spiltype",
    "infoGameTypeDefault": "Pointbaseret sidegame",
    "infoWeightTitle": "Vægtindstilling",
    "infoWeightValue": "Aktuel vægt: {weight}%",
    "infoWeightHelp": "Vægten styrer hvor meget spillet påvirker totalpoint. 100% giver fuld effekt, lavere værdier reducerer effekten.",
    "closeVideo": "Luk",
    "gameLoadError": "Kunne ikke indlæse spil",
    "gameStartError": "Kunne ikke starte spil",
    "startGame": "Start spil",
    "startRound": "Start runde",
    "updateCta": "Gem og fortsæt",
    "meritsLabel": "meritter",
    "meritsPerTeamLabel": "meritter per hold",
    "meritsPerAchievementLabel": "meritter per præstation",
    "meritsPerEventLabel": "meritter per event",
    "meritDistributionTitle": "Meritfordeling",
    "meritDistributionTotal": "{merits} meritter til vinderen",
    "meritDistributionTotalTour": "{merits} meritter at vinde over {rounds} runder",
    "meritWeightSetByTour": "Styres af touren",
    "meritLadderA11y": "Meritter per placering for {name}: {ladder}, vægt {weight}%",
    "tournamentManagedLocked": "Styret af turneringen",
    "rulesButton": "Regler",
    "rulesSectionTitle": "Regler",
    "rulesTitle": "Regler for {name}",
    "rulesSubtitleRound": "Vælg regelsæt for denne runde.",
    "rulesSubtitleTour": "Vælg regelsæt som nye runder i touren starter med.",
    "rulesBack": "Tilbage",
    "rulesClose": "Luk",
    "rulesDefaultBadge": "Standard",
    "rulesTourDefaultBadge": "Tourens standard",
    "rulesEmpty": "Dette spil har ét regelsæt.",
    "rulesReadOnlyHint": "Bestemmes af touren.",
    "rulesNoDescription": "Ingen beskrivelse tilgængelig.",
    "rulesA11ySelect": "Brug regelsæt {name}",
    "rulesTileLabel": "Regler: {name}"
  },
  "roundStartSetup": {
    "title": "Rundeindstillinger",
    "subtitleNamed": "Konfigurer spillere og spil for {name}",
    "subtitleFallback": "Konfigurer spillere og spil for denne runde",
    "loading": "Indlæser rundestart...",
    "loadError": "Kunne ikke indlæse rundestart.",
    "playersTitle": "Rundespillere",
    "playersEmpty": "Ingen spillere koblet til runden.",
    "playingHandicapLabel": "Spil-hcp",
    "playingHandicapPlaceholder": "Spil-hcp",
    "addHandicap": "Angiv hcp",
    "editPlayer": "Rediger spiller",
    "playerNameLabel": "Navn",
    "handicapHelp": "Spillerens spille-hcp for denne runde (-10 til 54).",
    "saveHandicap": "Gem",
    "newPlayer": "Ny spiller",
    "pickFriend": "eller vælg en ven",
    "searchFriends": "Søg venner…",
    "addedPlayers": "Tilføjede",
    "hcpSourcePlayer": "Spillerens hcp fra seneste runde her",
    "hcpSourceCalculated": "Beregnet spille-hcp for valgt tee",
    "hcpSourceDefault": "Standard – justér til spillerens hcp",
    "hcpSourceProfile": "Spillerens hcp fra profilen – justér til banen",
    "groupsTitle": "Grupper og hold",
    "groupsHint": "Træk en spiller over en holdkammerats kort for at komme på holdet, over en anden gruppe for at bytte plads, eller tryk på to kort for at bytte.",
    "groupsLocked": "Grupper er låst, når runden ikke længere er draft.",
    "groupsEmpty": "Ingen gruppelayout tilgængelig.",
    "groupsUneven": "Holdene er ulige – gør dem lige, før grupperne kan gemmes eller runden startes.",
    "groupsNewTeamHint": "Slip her for at starte et nyt hold",
    "groupLabel": "Gruppe {index}",
    "teamLabel": "Hold {index}",
    "groupsUpdateSending": "Gemmer gruppebytte...",
    "groupsUpdateSaved": "Grupper opdateret.",
    "groupsUpdateQueued": "Gruppebytte står i kø, indtil websocket er tilbage.",
    "groupsUpdateRejected": "Kunne ikke opdatere grupper.",
    "groupsUpdateSendFailed": "Kunne ikke sende gruppebytte.",
    "groupsUpdateTimeout": "Timeout ved bekræftelse af gruppebytte.",
    "gamesTitle": "Rundespil",
    "gamesEmpty": "Ingen spil koblet til runden.",
    "addMoreGamesCta": "Tilføj flere spil",
    "removePlayerCta": "Fjern",
    "removingPlayer": "Fjerner spillere...",
    "removeQueued": "Fjernelse af spillere sat i kø.",
    "removeSent": "Spilleren er borttagen.",
    "removeRejected": "Det lykkedes ikke at fjerne spilleren fra runden.",
    "disableGameCta": "Deaktiver",
    "enableGameCta": "Aktivér",
    "gamesUpdateQueued": "Rundeopdatering sat i kø.",
    "gamesUpdateSent": "Rundespil opdateret.",
    "updateCta": "Opdater",
    "openRoundCta": "Åbn runde",
    "openRoundSending": "Åbner runde...",
    "openRoundQueued": "Rundens statusopdatering sat i kø.",
    "openRoundConfirmed": "Runden er nu aktiv.",
    "openRoundSendFailed": "Kunne ikke sende rundens statusopdatering.",
    "openRoundTimeout": "Runden blev ikke aktiv i tid. Prøv igen."
  },
  "tourLeaderboard": {
    "title": "Turneringsledertavle",
    "tourName": "Tour: {name}",
    "roundCount": "Runder: {count}",
    "overallTitle": "Samlet stilling",
    "roundsPlayed": "{count} runder",
    "highlightsTitle": "Højdepunkter",
    "highlightBestRound": "Bedste runde",
    "highlightMostWins": "Flest rundesejre",
    "highlightLatestWinner": "Seneste rundevinder",
    "highlightLead": "Føringsmargin",
    "perGameTitle": "Resultater pr. spil",
    "winsCount": "{count} sejre",
    "parBetterTitle": "Par eller bedre",
    "albatrossCount": "{count} albatros",
    "eaglesCount": "{count} eagles",
    "birdiesCount": "{count} birdies",
    "parsCount": "{count} par",
    "points": "{points} p",
    "gamePoints": "{points} p",
    "player": "Spillere",
    "total": "Turnering",
    "gameFallback": "Spil",
    "roundsTitle": "Runder",
    "roundSectionsTitle": "Runder",
    "roundSectionTitle": "Runde {round}: {name}",
    "roundMembersEmpty": "Ingen medlemmer i denne runde.",
    "roundRowLabel": "Runde",
    "roundFallback": "Runde",
    "roundEmpty": "Ingen point endnu.",
    "empty": "Ingen resultater endnu.",
    "loadError": "Kunne ikke indlæse leaderboard.",
    "wsConnecting": "Forbinder til live leaderboard...",
    "wsWaitingData": "Forbundet. Venter på leaderboard-data...",
    "wsRetrying": "Venter stadig på leaderboard-data (forsøg {count}).",
    "unknownPlayer": "Ukendt spiller",
    "resultsHeader": "Resultater",
    "resultsButton": "Graf",
    "resultsTitle": "Turneringresultater",
    "resultsTableTitle": "Resultattabel",
    "resultsClose": "Luk",
    "resultsError": "Kunne ikke indlæse resultater.",
    "resultsTableButton": "Tabel",
    "downloadCsv": "Download CSV",
    "csvError": "Ingen turneringresultater at downloade.",
    "csvUnsupported": "CSV-download findes kun på nettet.",
    "roundPoints": "Rundepoint",
    "claimHeader": "Claim",
    "claimCta": "Claim",
    "claiming": "Claimer...",
    "claimPending": "Anmodning om claim sendt.",
    "claimSuccess": "Spilleren er nu claimet til din profil.",
    "claimTokenMissing": "Claim lykkedes, men midlertidig adgang kunne ikke etableres. Prøv igen.",
    "claimRejected": "Det lykkedes ikke at claime spilleren.",
    "claimSendError": "Kunne ikke sende claim-anmodning.",
    "claimTimeout": "Intet svar på claim-anmodningen. Tjek forbindelsen og prøv igen.",
    "claimReleaseCta": "Annullér claim",
    "claimReleaseSendError": "Kunne ikke annullere claim.",
    "claimReleased": "Claim er annulleret.",
    "waitingForRoundSetupTitle": "Rundeopsætning I Gang",
    "waitingForRoundSetup": "Venter på at rundeopsætningen bliver færdig. Du sendes automatisk til hul 1.",
    "membersTitle": "Turneringmedlemmer",
    "membersClaimHint": "Claim midlertidige medlemmer her.",
    "membersReadOnlyHint": "Log ind for at claime midlertidige medlemmer.",
    "unassignedPlayersTitle": "Ikke-claimede spillere",
    "unassignedPlayersHint": "Vælg din spiller for at begynde at indtaste score.",
    "unassignedPlayersEmpty": "Ingen ikke-claimede spillere tilbage.",
    "membersEmpty": "Ingen medlemmer i denne turnering.",
    "memberTemporary": "Midlertidigt medlem",
    "memberClaimed": "Tilknyttet medlem",
    "eclecticTitle": "Eclectic",
    "eclecticSubtitle": "Bedste Stablefordpoint pr. hul på tværs af alle runder",
    "eclecticGridHint": "Bedste point pr. hul, med runden de kom fra",
    "freezeTitle": "Eclectic Freeze",
    "freezeSubtitle": "Låste point indtil videre – åbne huller tæller i sidste runde",
    "freezeFinalSubtitle": "Slutresultat: låste point + sidste runde på åbne huller",
    "freezeFinalRoundSubtitle": "Sidste runde i gang: låste point + løbende point på åbne huller",
    "freezeMerits": "+{merits} p",
    "tourGamesHeader": "Tour-spil",
    "highlightBestParAvg": "Bedste par {par}-snit",
    "strokesAvg": "{avg} slag",
    "freezeLockedCount": "{locked}/{total} låst",
    "freezeLockedAvg": "gns. {avg}",
    "freezeGridHint": "Låst {locked} + åben {open}",
    "freezeGridHintLocked": "Låst {locked}",
    "freezeStale": "mangler",
    "freezeLockCta": "Frys huller",
    "missingTour": "Ingen turnering valgt.",
    "goTours": "Gå til turneringer"
  },
  "tourPreview": {
    "title": "Tourens overblik",
    "loading": "Henter touren…",
    "loadFailed": "Kunne ikke hente tourens overblik.",
    "retry": "Prøv igen",
    "dateNotSet": "Dato ikke fastlagt",
    "courseNotChosen": "Bane ikke valgt endnu",
    "courseNotMapped": "Banekort mangler endnu",
    "playPreview": "Afspil baneoverblik",
    "holesCount": "{count} huller",
    "holeCaption": "Hul {number}",
    "parShort": "Par {par}",
    "strokeIndexShort": "Indeks {strokeIndex}",
    "play": "Afspil",
    "pause": "Pause",
    "previousHole": "Forrige",
    "nextHole": "Næste"
  },
  "tourPhotos": {
    "title": "Turneringsbilleder",
    "openAction": "Billeder",
    "count": "{count} billeder",
    "filterAll": "Alle",
    "filterUnassigned": "Ingen runde",
    "unnamedRound": "Runde",
    "empty": "Ingen billeder endnu",
    "emptyHint": "Billeder du tager under en runde vises her.",
    "loadError": "Kunne ikke hente billederne.",
    "holeLabel": "Hul {hole}",
    "unknownUploader": "Ukendt spiller",
    "delete": "Slet",
    "deleteConfirm": "Slet billedet for alle i turneringen?",
    "deleteConfirmYes": "Slet billede",
    "cancel": "Annuller",
    "close": "Luk",
    "captureAction": "Tag billede",
    "pickAction": "Tilføj fra galleriet",
    "uploading": "Uploader {count}…",
    "uploadFailed": "Et billede kunne ikke uploades. Det ligger stadig i galleriet – prøv igen.",
    "cameraDenied": "Kameraadgang er slået fra. Slå den til i enhedens indstillinger.",
    "libraryDenied": "Adgang til galleriet er slået fra. Slå den til i enhedens indstillinger.",
    "tooLarge": "Billedet er for stort (maks. 15 MB).",
    "unsupportedType": "Brug et JPEG-, PNG- eller WebP-billede.",
    "uploadFailedTitle": "Billedet blev ikke uploadet",
    "setAsTourImage": "Brug som turneringsbillede",
    "setAsTourImageQueued": "Gemt som turneringsbillede. Det kan tage et øjeblik, før det vises.",
    "setAsTourImageFailed": "Kunne ikke sætte turneringsbilledet. Prøv igen.",
    "makePublic": "Gør offentligt",
    "makePrivate": "Gør privat",
    "publicNote": "Offentligt – alle med linket kan se dette billede.",
    "visibilityFailed": "Kunne ikke ændre, hvem der kan se billedet. Prøv igen.",
    "shareAction": "Del link",
    "shareCopied": "Linket er kopieret.",
    "shareFailed": "Kunne ikke dele linket."
  },
  "tourInvite": {
    "title": "Invitation",
    "courseLabel": "Bane",
    "viewerTitle": "Vil du bare se med?",
    "viewerHint": "Følg touren, runderne og livescoringen uden at claime en spiller.",
    "viewerCta": "Se med som tilskuer"
  },
  "scorecard": {
    "title": "Scorekort",
    "player": "Spillere",
    "hole": "Hul",
    "par": "Par",
    "index": "Index",
    "strokes": "Slag",
    "points": "Point",
    "out": "Ut",
    "in": "In",
    "total": "Totalt",
    "totalGross": "Slag",
    "totalStableford": "Point",
    "selectRoundTitle": "Vælg runde",
    "selectRoundLoading": "Indlæser runder...",
    "selectRoundEmpty": "Ingen runder tilgængelige.",
    "selectRound": "Vælg",
    "selectRoundError": "Kunne ikke indlæse runder.",
    "selectRoundFallback": "Runde",
    "missingRound": "Ingen runde vald.",
    "loadError": "Kunne ikke indlæse scorekort."
  },
  "language": {
    "english": "Engelsk",
    "label": "Sprog",
    "swedish": "Svensk",
    "danish": "Dansk"
  },
  "modal": {
    "title": "Modal"
  },
  "deviceLink": {
    "title": "Log ind",
    "message": "Sender dig til login…"
  },
  "notFound": {
    "cta": "Gå til startskærmen!",
    "message": "Denne skærm findes ikke.",
    "title": "Ups!"
  },
  "qr": {
    "fallbackError": "Bruger reservelink, fordi backend ikke er tilgængelig.",
    "subtitle": "Eller tryck nedan for at åbne den direkt",
    "title": "Scan for at åbne linket"
  },
  "tab": {
    "qr": "QR-link",
    "players": "Spillere"
  },
  "players": {
    "addedAt": "Tilføjet: {date}",
    "empty": "Ingen spillere endnu.",
    "loadError": "Det lykkedes ikke at indlæse spillere.",
    "serviceError": "Fejl i spillertjenesten",
    "title": "Spillere",
    "roundInitTitle": "Ny runde",
    "wsError": "WebSocket-forbindelsen mislykkedes.",
    "tourId": "Tour-ID: {id}",
    "tourNameFallback": "Tour",
    "activeRoundsTitle": "Aktive runder",
    "activeRoundsRefresh": "Opdater",
    "activeRoundsEmpty": "Ingen aktive runder fundet.",
    "roundsLoadError": "Det lykkedes ikke at indlæse runder.",
    "roundStatus": "Status: {status}",
    "roundStatusWithDate": "Status: {status} · {date}",
    "roundOpen": "Åbn",
    "roundContinue": "Fortsæt",
    "roundFallbackName": "Bane",
    "finishedRoundsTitle": "Afsluttede runder",
    "roundResults": "Resultater",
    "roundMenuLabel": "Rundehandlinger",
    "roundMenuPause": "Pause",
    "roundMenuFinish": "Afslut",
    "roundMenuCancel": "Annuller",
    "roundNamePlaceholder": "Rundenavn",
    "roundDescriptionTitle": "Rundebeskrivning",
    "roundDescriptionPlaceholder": "Tilføj en beskrivning...",
    "roundDescriptionButton": "Rediger rundebeskrivning",
    "playDateLabel": "Spildato",
    "playDateQuick": "Hurtige datoer",
    "playDateToday": "I dag",
    "holesCountLabel": "Antal hul",
    "courseLabel": "Bane",
    "courseSearchPlaceholder": "Søg bane",
    "courseSearchEmpty": "Ingen baner fundet.",
    "addCourse": "Tilføj bane",
    "holesCountOptionLabel": "{count} hul",
    "holesCountOptionValue": "{count} hul",
    "teeLabel": "Tee",
    "teeNone": "Ingen",
    "addTee": "Tilføj tee",
    "addTeeTitle": "Tilføj tee",
    "addTeeNameLabel": "Navn",
    "addTeeNamePlaceholder": "Tee-navn",
    "addTeeCourseRatingLabel": "Course rating (valgfrit)",
    "addTeeSlopeRatingLabel": "Slope rating (valgfrit)",
    "addTeeSave": "Tilføj tee",
    "addTeeNameRequired": "Tee-navn er påkrævet.",
    "addTeeNeedsCourse": "Vælg en bane først.",
    "addTeeFailed": "Kunne ikke tilføje tee. Prøv igen.",
    "addTemporary": "Tilføj midlertidig spiller",
    "temporaryNamePlaceholder": "Navn på midlertidig spiller",
    "temporaryCreateAction": "Opret spillere",
    "temporaryNameRequired": "Angiv navn for midlertidig spiller.",
    "temporaryCreateFailed": "Det lykkedes ikke at oprette midlertidig spiller.",
    "temporaryCreatePending": "Vent til de midlertidige spillere er oprettet, før runden startes.",
    "temporaryCreatePendingCount": "Opretter midlertidige spillere: {count}",
    "inviteOthers": "Inviter andre",
    "joinWithCode": "Deltag med kode",
    "showQr": "Vis QR",
    "selectFromMembership": "Vælg spillere fra turneringens medlemslista.",
    "membersUpdateTimeout": "Ingen bekræftelse på opdatering af turneringsmedlemmer.",
    "membersUpdateSendFailed": "Det lykkedes ikke at sende opdatering af turneringsmedlemmer.",
    "roundInitiateSendFailed": "Det lykkedes ikke at starte runden.",
    "roundInitiateTimeout": "Start af runde tog for lang tid.",
    "roundInitiateRejected": "Start af runde blev afvist.",
    "missingTour": "Turnering mangler, kan ikke gemme spillere.",
    "singleRoundHiddenTourName": "Enkelt runde",
    "hiddenTourInitiateFailed": "Det lykkedes ikke at starte enkelt runde lige nu.",
    "recentlyPlayedTitle": "Senest spillet",
    "recentlyPlayedSubtitle": "Dine seneste runder",
    "searchAnyCourseHint": "Søg en hvilken som helst klub, bane eller by",
    "lookingForAnother": "Leder du efter en anden bane?",
    "nearbyCoursesTitle": "Baner i nærheden",
    "courseOfficialBadge": "Officiel",
    "coursePrivateBadge": "Privat",
    "coursePendingBadge": "Afventer"
  },
  "round": {
    "member": {
      "add": {
        "alreadyMember": "Spilleren indgår allerede i denne runde.",
        "statusNotAllowed": "Spillere kan kun tilføjes, når rundens status er draft, active eller playing.",
        "roundNotFound": "Runden kunne ikke findes.",
        "invalid": "Anmodning om tilføjelse af rundespillere er ugyldig.",
        "playerNotInTour": "Spilleren skal være medlem af turneringen, før den kan tilføjes til runden."
      },
      "remove": {
        "invalid": "Anmodning om fjernelse af rundespillere er ugyldig.",
        "invalidPlayer": "Fjernelse af rundespillere kræver en gyldig spiller.",
        "roundNotFound": "Runden kunne ikke findes.",
        "notMember": "Spilleren indgår ikke i denne runde.",
        "lastPlayer": "En runde skal have mindst én spiller tilbage.",
        "hasScores": "Spilleren kan ikke fjernes fra runden efter at scorer har registreret."
      }
    },
    "remove": {
      "invalid": "Anmodning om fjernelse af runde er ugyldig.",
      "roundNotFound": "Runden kunne ikke findes.",
      "hasScores": "Runden kan ikke fjernes efter at scorer har registreret."
    },
    "initiate": {
      "membershipRequired": "Alle rundespillere skal være medlemmer af turneringen."
    }
  },
  "roundResults": {
    "title": "Runderesultater",
    "backToHole": "<- Runderesultater",
    "missingRound": "Vælg en runde for at se resultater.",
    "goPlayers": "Til spillere",
    "loadError": "Kunne ikke indlæse rundresultater.",
    "empty": "Ingen resultater endnu.",
    "player": "Navn",
    "total": "Point",
    "gameFallback": "Spil",
    "unknownPlayer": "Spillere",
    "roundFallback": "Runde",
    "status": "Status: {status}"
  },
  "gameGroups": {
    "main": "Hovedspil",
    "match": "Matchspil",
    "team": "Holdspil",
    "hazard": "Hazardspil",
    "achievement": "Præstationer",
    "challenge": "Udfordringer",
    "other": "Øvrige spil",
    "tournament": "Tourspil"
  },
  "summary": {
    "title": "Rundesammenfatning",
    "missingInfo": "Mangler runde-ID eller brugertoken.",
    "loadError": "Kunne ikke indlæse rundedata.",
    "overallTitle": "Total leaderboard",
    "playerHeader": "Spillere",
    "scoreHeader": "Score",
    "gameHeader": "Pinde",
    "pointsHeader": "Totalpoint",
    "eventsCount": "{count} hændelser",
    "gamesTitle": "Resultater per spil",
    "gamesEmpty": "Ingen spilresultater endnu.",
    "hazardsTitle": "Hazardspil",
    "hazardsEmpty": "Ingen hazard-hændelser registreret.",
    "hazardTotal": "Totalt {count}",
    "hazardWater": "Vand {count}",
    "hazardBunker": "Bunker {count}",
    "hazardThreePutt": "3-put {count}",
    "hazardPenalty": "Straf {count}",
    "pointsValue": "{points} point",
    "meritsValue": "{merits} pinde",
    "positionByHoleTitle": "Placering per hul",
    "positionByHoleEmpty": "Ingen placeringshistorik registreret endnu.",
    "strokesValue": "{strokes} slag",
    "piecesValue": "{pieces} stk",
    "holesValue": "{holes} huller",
    "skinsValue": "{skins} skins",
    "mysteryTitle": "Mystery-spil højdepunkter",
    "mysteryEmpty": "Ingen mystery-val fundet.",
    "mysteryHolePrize": "Hul {hole} - {prize}",
    "mysterySubgame": "Delspil: {subgame}",
    "mysteryWinner": "Vinder: {winner}",
    "mysteryPrizeFallback": "Mystery-pris",
    "parBetterTitle": "Par eller bedre pr. spiller",
    "parBetterEmpty": "Ingen par-eller-bedre resultater endnu.",
    "parBetterHoles": "Hul: {holes}",
    "parBetterHolesWithResult": "Hul: {holes}",
    "resultPar": "par",
    "resultBirdie": "birdie",
    "resultEagle": "eagle",
    "resultAlbatross": "albatross",
    "resultUnderPar": "under par",
    "unknownPlayer": "Ukendt spiller",
    "unknownGame": "Ukendt spil",
    "unknownWinner": "Ukendt vinder",
    "unknownMysteryPrize": "Ukendt mystery-pris",
    "reopenRoundButton": "Åbn runden igen",
    "doneButton": "OK",
    "shotTrackingTitle": "Slagmåling",
    "shotTrackingHole": "Hul {hole}",
    "shotTrackingShots": "{count} slag",
    "shotTrackingPutts": "{putts} putts"
  },
  "tour": {
    "member": {
      "claim": {
        "invalid": "Anmodning om at claime turneringspillere er ugyldig.",
        "unauthorized": "Log ind for at claime spilleren.",
        "tourNotFound": "Turneringen kunne ikke findes.",
        "sourceNotFound": "Spilleren kunne ikke findes.",
        "sourceNotMember": "Spilleren indgår ikke i denne turnering.",
        "sourceNotUnclaimed": "Spilleren er allerede claimet.",
        "targetMissing": "Opret din spillerprofil, før du claimer denne spiller.",
        "targetAlreadyInRound": "Din spillere findes allerede i en eller flere runder i denne turnering.",
        "mergeConflict": "Claim kunne ikke gennemføres, fordi rundedata kolliderer med din eksisterende spiller.",
        "targetAlreadyInTour": "Din spillere er allerede med i denne turnering."
      },
      "remove": {
        "invalid": "Anmodning om fjernelse af turneringspillere er ugyldig.",
        "invalidPlayer": "Fjernelse af turneringspillere kræver en gyldig spiller.",
        "tourNotFound": "Turneringen kunne ikke findes.",
        "notMember": "Spilleren indgår ikke i denne turnering.",
        "creatorProtected": "Turneringens oprettere kan ikke fjernes.",
        "lastMember": "En turnering skal have mindst ét medlem tilbage.",
        "roundLastPlayer": "Spilleren kan ikke fjernes eftersom en runde då blir tom.",
        "hasScores": "Spilleren kan ikke fjernes fra turneringen efter at scorer har registreret."
      }
    },
    "initiate": {
      "creatorPlayerRequired": "Opret din spillerprofil, før du opretter en turnering.",
      "invalidPlayers": "En eller flera valda spillere kunne ikke findes.",
      "maxPlayersExceeded": "En turnering kan have maks. 8 spillere."
    }
  },
  "mysteryPrize": {
    "title": "Mysterypris",
    "subtitle": "Vælg et hul og et delspil for hver spiller.",
    "loading": "Indlæser mystery-setup...",
    "loadError": "Kunne ikke indlæse mysterypriset.",
    "validationError": "Vælg et hul og et delspil for hver spiller.",
    "noPlayers": "Ingen spillere fundet for runden.",
    "noSubgames": "Ingen delspil tilgængelige.",
    "holeLabel": "Hul",
    "subgameLabel": "Delspil",
    "selectHole": "Vælg hul",
    "selectSubgame": "Vælg delspil",
    "save": "Gem mysterypris",
    "skip": "Spring mysterypris over",
    "saving": "Gemmer...",
    "holePickerTitle": "Vælg hul",
    "subgamePickerTitle": "Vælg delspil",
    "holeTaken": "Optaget"
  },
  "hole": {
    "title": "Hul",
    "holeLabel": "Hul",
    "loading": "Indlæser hul...",
    "notRoundMember": "Du er ikke spiller i denne runde — livevisning er ikke tilgængelig.",
    "scoreButtonLabel": "Score",
    "frozenHoleBadge": "Hullet er frosset",
    "frozenHoleBadgePoints": "Hullet er frosset på {points} point",
    "unfrozenHoleBadge": "Hullet er ikke frosset",
    "unfrozenHoleBadgePoints": "Hullet er ikke frosset, {points} point at fryse",
    "eclecticBestBadge": "Eclectic bedste indtil nu {points} point",
    "scorePopupTitle": "{name} - {holeLabel} {hole}",
    "scorePopupHandicapLabel": "Handicap-slag {value}",
    "scorePopupHandicapAndIndexLabel": "Handicap-slag {handicap} · Hcp-index {index}",
    "scorePopupMeta": "Hcp-index {hcpIndex} · Par {par}",
    "placeholder": "Pointregistrering kommer her.",
    "roundId": "Runde: {id}",
    "tourId": "Tour: {id}",
    "gameFallbackName": "Spil",
    "playerBreakdownTitle": "Point for {name}",
    "playerBreakdownEmpty": "Ingen point at vise.",
    "positionShort": "Plads {position}",
    "positionShared": "deled",
    "roundPointsMissing": "-",
    "leaderboardShortTitle": "Leaderboard (Pinde)",
    "roundColumn": "Runde",
    "tourColumn": "Tour",
    "leaderboardRoundTitle": "⛳️ Leaderboard - runde (Turnering)",
    "noGamesSelected": "Ingen spil valgt. Leaderboarden er skjult.",
    "unknownPlayer": "Ukendt spiller",
    "gamesTitle": "🏆 Spil",
    "mysteryPrizeTitle": "Mysterypris",
    "mysteryPrizeSetup": "Mysterypris",
    "skinsCarry": "💰 Skins: {count} skins på spil på dette hul!",
    "skinsCarryNext": "💰 Skins: {count} skins på spil på næste hul!",
    "shotTracker": {
      "lastShot": "🎯 {count} slag · seneste {distance}",
      "countOnly": "🎯 {count} slag registreret",
      "putts": " · {putts} putts"
    },
    "missingRound": "Ingen runde vald.",
    "goPlayers": "Gå til spillere",
    "mysteryPrizeEntry": "{subgame} - {player}",
    "mysteryPrizeEntryWinner": "{subgame} - {player} (vinder {winner})",
    "mysteryPrizeNone": "Intet mysterypris for dette hul.",
    "noPlayers": "Ingen spillere at vise.",
    "puttOne": "1 put",
    "puttTwo": "2 put",
    "puttThree": "3 put",
    "puttPlus": "+ put",
    "eightPlusLabelWithValue": "8+({value})",
    "mysteryPrizeUnknownSubgame": "Ukendt delspil",
    "mysteryPrizeUnknownPlayer": "Ukendt spiller",
    "mysteryPrizeWinnerTitle": "Vælg vinder",
    "mysteryPrizeWinnerSaveFailed": "Kunne ikke gemme mystery prize-vinder.",
    "mysteryPrizeNextHoleTitle": "Mysterypris næste hul",
    "mysteryPrizeNextHoleSubtitle": "På hul {hole} er mysteryprisen valgt sådan her:",
    "mysteryPrizeSelectWinner": "Vælg vinder",
    "mysteryPrizeBack": "Tilbage",
    "backButton": "<- Tilbage",
    "showDetails": "Vis detaljer",
    "hideDetails": "Skjul detaljer",
    "pickup": "Pickup",
    "scoreChangeConfirmTitle": "Ændr score?",
    "scoreChangeConfirmMessage": "{name} har allerede {current} på dette hul. Vil du ændre til {next}?",
    "scoreChangeConfirmCta": "Ændr",
    "scoreChangeConfirmCancel": "Annuller",
    "roundStateTitle": "Round state",
    "roundStateEmpty": "Ingen round state modtaget.",
    "close": "Luk",
    "matchDormie": "Dormie i {game}: {team} fører med {lead} og {holes} huller tilbage",
    "matchWon": "{team} har vundet {game}: {lead} op med {holes} huller tilbage",
    "matchTeamFallback": "Hold",
    "leaderboardChangeTitle": "Leaderboard ændret",
    "leaderboardChangeSubtitle": "Alle scorer er registreret for hul {hole}",
    "leaderboardChangeViewLeaderboard": "Vis leaderboard",
    "leaderboardChangeContinue": "Fortsæt",
    "netScoreLabel": "Netto",
    "netSummary": "Netto {net}{vsPar}",
    "netSummaryEmpty": "Netto –",
    "stablefordLabel": "Stableford",
    "menuTitle": "Vælg hul",
    "menuButton": "Hul {hole}",
    "menuPlayed": "Spillet",
    "menuNotPlayed": "Ej spillet",
    "menuMyScore": "Min score: {score}",
    "menuScoreMissing": "—",
    "menuCurrent": "Aktuelt hul",
    "prevHole": "Forrige hul",
    "prevHoleSwipeHint": "Stryg igen for at gå til forrige hul.",
    "nextHole": "Næste hul",
    "nextHoleSwipeHint": "Stryg igen for at gå til næste hul.",
    "finishRound": "Afslut runde",
    "finishRoundHint": "Tryk for at afslutte runden.",
    "holeViewTitle": "Hul {hole}",
    "holeViewBeta": "Beta",
    "holeViewDisclaimerToggle": "Beta Ansvarsfraskrivelse",
    "holeViewBetaNotice": "Beta: positionerne kommer fra banekortlægningen og telefonens GPS. Afstandene er skøn og kan være forkerte – kontrollér dem, før du vælger kølle.",
    "holeViewDistance": "{distance} fra bagerste tee til greenens midte",
    "holeViewElevationUphill": "{change} opad til greenen",
    "holeViewElevationDownhill": "{change} nedad til greenen",
    "holeViewElevationLevel": "Greenen ligger i niveau med dig",
    "holeViewToGreen": "Til greenens midte",
    "holeViewHoleLength": "Hullets længde",
    "holeViewYou": "Dig",
    "holeViewTargetHint": "Tryk på kortet for at måle til et punkt",
    "holeViewTargetFromYou": "Dig til punkt",
    "holeViewTargetFromTee": "Tee til punkt",
    "holeViewTargetToGreen": "Punkt til green",
    "holeViewTargetClear": "Ryd",
    "holeViewZoomFit": "Tilpas",
    "holeViewFlyover": "Overflyvning",
    "holeViewBasemap_satellite": "Satellit",
    "holeViewBasemap_hazards": "Forhindringer",
    "holeViewBasemap_drawing": "Tegning",
    "holeViewShapesNotice": "Bunkers, vand og greens findes automatisk i satellitbilleder og er ikke gennemgået. Tjek dem mod det, du kan se.",
    "holeViewWind_calm": "Vindstille",
    "holeViewWind_helping": "Medvind",
    "holeViewWind_into": "Modvind",
    "holeViewWind_leftToRight": "Fra venstre",
    "holeViewWind_rightToLeft": "Fra højre",
    "holeViewLocating": "Finder din position…",
    "holeViewOffHole": "Du er ikke på dette hul, så længden måles fra bagerste tee.",
    "holeViewLocationDenied": "Placering er slået fra, så længden måles fra bagerste tee.",
    "holeViewLocationUnavailable": "Ingen position tilgængelig, så længden måles fra bagerste tee.",
    "holeViewTee": "Tee",
    "holeViewGreenCentre": "Greenens midte",
    "holeViewHazardBunker": "Bunker",
    "holeViewHazardWater": "Vand",
    "holeViewHazardToggle": "Afstand til forhindringer",
    "holeViewUnavailable": "Hullet er ikke kortlagt endnu. Tee- og greenpositioner vises, når banen er blevet kortlagt.",
    "finishSendFailed": "Det lykkedes ikke at afslutte runden.",
    "eventSendFailed": "Det lykkedes ikke at sende hændelsen.",
    "offlinePending": "Offline — {count} gemt",
    "offlineSyncing": "Synkroniserer…",
    "offlineSynced": "Synkroniseret",
    "offlineSyncFailed": "{count} poster kunne ikke synkroniseres",
    "offlineRoundClosed": "Runden er afsluttet — genåbn den for at registrere",
    "event": {
      "water": "Vand",
      "penalty": "Straf",
      "bunker": "Bunker",
      "threePutt": "3 put",
      "chipIn": "Chip i",
      "fairway": "Fairway",
      "putts": "Put",
      "gir": "GIR"
    },
    "enhanced": {
      "unset": "–",
      "fairwayHit": "Ramt",
      "fairwayLeft": "Venstre",
      "fairwayRight": "Højre",
      "girHit": "Ramt",
      "girMiss": "Misset",
      "fairwayPrevious": "Fairway, forrige",
      "fairwayNext": "Fairway, næste",
      "puttsDecrease": "Én putt færre",
      "puttsIncrease": "Én putt mere"
    },
    "parBadge": "Par {par}",
    "hcpIndexBadge": "Index {hcpIndex}",
    "distanceToGreenBadge": "{distance}",
    "playersLoadFailed": "Kunne ikke hente spillere.",
    "holeViewAnalysis": "Dataanalyse",
    "holeViewReportInaccurate": "Rapportér unøjagtige data",
    "holeViewReported": "Tak – rapporteret",
    "holeViewReanalyze": "Analysér banen igen",
    "holeViewReanalyzeRequesting": "Anmoder…",
    "holeViewReanalyzeQueued": "I kø til ny analyse",
    "holeViewReanalyzeUnavailable": "Ny analyse er ikke tilgængelig"
  },
  "games": {
    "definitions": {
      "2f1c8d3a-6b54-4e29-9a7d-1c0e5b8f3a42": {
        "name": "København",
        "info": "Spil for tre: bedste netto pr. hul giver 4, midten 2, dårligste 0.",
        "description": "København er et spil for tre spillere, der scores på nettoslag hul for hul. Bedste netto giver 4 point, midterspilleren 2 og dårligste 0. Spillere med samme placering deler de samlede point ligeligt (delt føring 3/3/0, delt sidste 4/1/1, alle lige 2/2/2). Flest point efter runden vinder."
      },
      "3fb77a04-e479-4cd7-9ed8-8e8e110b4c53": {
        "name": "Stableford",
        "info": "Pointspil baseret på resultater mod par pr. hul.",
        "description": "Spillere får point pr. hul ud fra nettoresultater mod par."
      },
      "c9d4b6a8-2a75-4d4f-bc35-9b0ec5b2f60b": {
        "name": "Slagspil",
        "info": "Laveste samlede antal slag vinder.",
        "description": "Spillere rangeres efter bruttoantal slag over runden, hvor lavere total giver bedre placering."
      },
      "d06818bc-beea-41cc-8c59-2c176d46ef53": {
        "name": "Skins",
        "info": "Hvert hul er en skin værd.",
        "description": "Bedste score på hullet vinder skin; deling ruller over til næste hul."
      },
      "8dbf1961-9d07-4e15-bf95-e81d55fe41a4": {
        "name": "Best Ball",
        "info": "Holdformat der tæller bedste score pr. hul.",
        "description": "Hvert hold tæller sin bedste spillers score på hvert hul."
      },
      "4d3a1a42-4f67-41a4-b63d-9a9b50a83f1f": {
        "name": "Bunker",
        "info": "Hændelsesspil for bunkerudfald.",
        "description": "Sporer bunkerhændelser under runden."
      },
      "e0b7c8af-3dc8-4a9f-8b77-5d99e5da0a4b": {
        "name": "Vand",
        "info": "Hændelsesspil for vandhazard.",
        "description": "Sporer vandhazard-hændelser under runden."
      },
      "f9d88a1b-1a7e-4c86-9b2e-8e7f7f0fcb2b": {
        "name": "3 put",
        "info": "Hændelsesspil for 3-put.",
        "description": "Sporer huller hvor spillere har brug for tre put."
      },
      "7a2e1c94-3b6d-4f81-9c2a-5d8e0f1a2b3c": {
        "name": "Chip i",
        "info": "Hændelsesspil for chip-in.",
        "description": "Giver et point hver gang en spiller chipper i på et hul."
      },
      "b1f4b6d5-3a7e-4d0a-8d3b-2e4f6a7b8c9d": {
        "name": "Mystery-pris",
        "info": "Hemmeligt sidespil med valgt delspil og hul.",
        "description": "Hver spiller får et skjult delspil for et valgt hul, hvorefter en vinder udpeges."
      },
      "3f6a1d9c-2b84-4e07-9d15-8c4a7e2f5b60": {
        "name": "Eclectic",
        "info": "Bedste Stablefordpoint pr. hul på tværs af alle tourrunder.",
        "description": "Et spil over hele touren: for hvert hul tæller dine bedste Stablefordpoint fra en hvilken som helst runde i touren. Summen over 18 huller er din Eclectic-score."
      },
      "9b4e7c21-6f5a-4d38-a1c9-0e8d3b6f7a52": {
        "name": "Eclectic Freeze",
        "info": "Lås Stablefordpoint på valgte huller efter hver runde.",
        "description": "Et sats over hele touren: efter hver runde låser du Stablefordpointene på huller, du er tilfreds med. Låste huller kan aldrig ændres. Huller, der stadig er åbne før sidste runde, får de point, du scorer der."
      },
      "9e183962-7a3d-4719-b7e3-f64f095b8b6e": {
        "name": "Bedste bold – dårligste bold",
        "info": "Holdspil, der sammenligner bedste og næstbedste nettoscore på hvert hul.",
        "description": "Holdene sammenligner deres nettoscorer position for position på hvert hul. Laveste netto i hver sammenligning giver et point."
      },
      "67fbf142-5a29-4e0d-bbe9-81bc4057d3cf": {
        "name": "Bingo Bango Bongo",
        "info": "Sjov- og pointspil",
        "description": "Point gives for først på greenen, tættest på flaget og først i hul."
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760001": {
        "name": "Birdie eller bedre",
        "info": "Præstation",
        "description": "Par eller bedre på hvert hul giver et point."
      },
      "a9099771-46ea-4210-91df-e4269c7428eb": {
        "name": "Høj–Lav",
        "info": "Holdspil",
        "description": "Holdets score er summen af den højeste og den laveste individuelle score på hvert hul."
      },
      "90c0ba8c-0fb0-4f5e-9a9e-4d2e8b1b0cc1": {
        "name": "Nassau",
        "info": "Hulspil / væddemål",
        "description": "Tre separate konkurrencer: de første ni, de sidste ni og alle 18 huller."
      },
      "6b9c72e0-6c1c-4d17-9f1f-6c0e2f71a742": {
        "name": "Strafslag",
        "info": "Hazardspil",
        "description": "Tæl strafslag per hul. Den sidste med en hazard får -1."
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760003": {
        "name": "Sandy par",
        "info": "Præstation",
        "description": "Bunker og alligevel par eller bedre giver et point."
      },
      "e1c62b4f-59a0-4b82-9c58-e4c6276933d0": {
        "name": "Vegas",
        "info": "Væddemålsspil",
        "description": "Holdenes scorer sættes sammen til et tocifret tal per hul, hvilket giver store udsving."
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760002": {
        "name": "Wet par",
        "info": "Præstation",
        "description": "Vandhazard og alligevel par eller bedre giver et point."
      },
      "4a6d988d-2077-4c1d-b6d6-e74f82d73115": {
        "name": "Wolf",
        "info": "Strategisk holdspil",
        "description": "En roterende spiller (ulven) vælger makker eller spiller alene mod gruppen."
      },
      "1b06cb5e-6edc-4d95-9c27-f008d9db7b98": {
        "name": "Dårligste bold",
        "info": "Holdspil",
        "description": "På hvert hul tæller den højeste score fra en spiller på holdet som holdets score."
      },
      "eab96a21-05ee-4a7d-8cdb-13ec27752158": {
        "name": "Irish",
        "info": "Holdspil hvor flere scorer tæller, jo længere runden skrider frem.",
        "description": "Et holdspil, der scores i netto-Stablefordpoint, hvor antallet af scorer, der tæller, vokser gennem runden. Over atten huller tæller den bedste bold på de første seks, de to bedste på de næste seks, de tre bedste på de følgende fire og alle scorer på de sidste to. En nihullers runde trappes op på samme måde. Antallet overstiger aldrig holdets størrelse, og flest point vinder."
      }
    },
    "subgames": {
      "d4d2a4b1-5a9b-4f0d-9b94-1a8f8a5c2e11": {
        "name": "Nærmest flag",
        "description": "Nærmest flaget på det valgte hul."
      },
      "3e92a03c-5b70-4a3a-aad1-7db36de37d5e": {
        "name": "Længste drive",
        "description": "Længste drive på det valgte hul."
      },
      "7c1cfd58-9171-4b4a-9a71-6f1d8b9b5c30": {
        "name": "Længste 1 put",
        "description": "Længste enkeltput på det valgte hul."
      },
      "f0385fe1-a689-433a-ae70-480532077b12": {
        "name": "Andet",
        "description": "En hvilken som helst anden udfordring, spillerne aftaler på det valgte hul."
      }
    },
    "ruleSets": {
      "f9d88a1b-1a7e-4c86-9b2e-8e7f7f0fcb2b": {
        "standard": {
          "name": "Standard",
          "description": "Et putte-sidespil. Et hul, hvor du bruger tre put eller flere, er et point værd, og det tæller én gang, uanset hvor mange put det faktisk blev. Det er den hurtigste måde at se, hvis kortspil svigtede."
        }
      },
      "9e183962-7a3d-4719-b7e3-f64f095b8b6e": {
        "standard": {
          "name": "Standard",
          "description": "Der er to point på spil hvert hul. Holdene stiller deres nettoscorer op i rækkefølge og sammenligner dem én mod én: bedste bold mod bedste bold, derefter næste bold mod næste bold. Hver sammenligning vindes af den laveste nettoscore, så tager man begge, vinder man hullet direkte, og deler man dem, bliver hullet delt. Det kræver, at holdet både har en lav runde og ingen passagerer."
        }
      },
      "8dbf1961-9d07-4e15-bf95-e81d55fe41a4": {
        "standard": {
          "name": "Standard",
          "description": "Et holdspil, hvor kun den bedste bold tæller. På hvert hul tager holdet sin laveste nettoscore og ser bort fra resten, så én spiller kan bære et hul, mens de andre samler op. Hver spiller, der matcher den bedste score, får pointet, hvilket belønner to holdkammerater, der spiller hullet godt sammen."
        },
        "gross": {
          "name": "Brutto",
          "description": "Det samme best ball-format spillet uden handicap. Der gives ingen slag, så holdets laveste faktiske score på hullet er den, der tæller."
        }
      },
      "67fbf142-5a29-4e0d-bbe9-81bc4057d3cf": {
        "standard": {
          "name": "Standard",
          "description": "Der er tre point på hvert hul, og de belønner position snarere end ren længde. Et går til den første bold på greenen, et til den, der er tættest på flaget, når alle bolde er oppe, og et til den første spiller i hullet. Spillerækkefølgen betyder noget, så den korteste slager kan score lige så frit som alle andre."
        }
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760001": {
        "standard": {
          "name": "Standard",
          "description": "Et point for hvert hul, du spiller i en under par eller bedre, så en birdie, en eagle og en albatros tæller hver især én gang. Det bedømmes på faktiske slag i stedet for nettoscore, hvilket betyder, at handicap ikke hjælper her. En enkel måde at belønne de modige huller i en ellers almindelig runde."
        }
      },
      "4d3a1a42-4f67-41a4-b63d-9a9b50a83f1f": {
        "standard": {
          "name": "Standard",
          "description": "Et sidespil, der tæller sand i stedet for scorer. Et hul, hvor du er i bunkeren, er et point værd, og et hul tæller højst én gang, uanset hvor mange besøg det bliver. Bliv enige før runden om, hvorvidt pointene er værd at have eller værd at undgå."
        }
      },
      "7a2e1c94-3b6d-4f81-9c2a-5d8e0f1a2b3c": {
        "standard": {
          "name": "Standard",
          "description": "Et point hver gang du holer ud fra uden for greenen, uanset om det er et chip, et pitch eller et bunkerslag. Et hul kan kun give point én gang, og det registreres, når det sker, i stedet for at blive regnet ud fra din score. Rent held tæller lige så meget som ren kunnen."
        }
      },
      "3f6a1d9c-2b84-4e07-9d15-8c4a7e2f5b60": {
        "standard": {
          "name": "Standard",
          "description": "Et spil, der løber over hele touren i stedet for en enkelt runde. For hvert hul tæller kun din bedste Stablefordscore på det fra en hvilken som helst runde i touren, og en bedre score senere erstatter en tidligere. Din eclectic-total er de atten bedste huller lagt sammen, så ét godt hul er i hus resten af touren."
        }
      },
      "9b4e7c21-6f5a-4d38-a1c9-0e8d3b6f7a52": {
        "standard": {
          "name": "Standard",
          "description": "Eclectic med et væddemål indbygget. Efter hver runde vælger du, hvilke huller du fryser, og låser dermed de Stablefordpoint, du har scoret på dem, og et frosset hul kan aldrig ændres igen, hverken til det bedre eller værre. Huller, du lader stå åbne, beholder det, du scorer på dem i sidste runde, så at fryse for tidligt spilder et godt hul, og at fryse for sent risikerer at miste et."
        }
      },
      "a9099771-46ea-4210-91df-e4269c7428eb": {
        "standard": {
          "name": "Standard",
          "description": "To separate point på hvert hul. Holdene sammenligner deres bedste nettobold med hinanden og deres værste nettobold med hinanden, og hver sammenligning er et point værd. Det holder en spiller, der kæmper, med i spillet, fordi den lave halvdel af hullet er lige så værdifuld som den høje."
        }
      },
      "2f1c8d3a-6b54-4e29-9a7d-1c0e5b8f3a42": {
        "standard": {
          "name": "Standard",
          "description": "Et spil for tre spillere, hvor seks point deles på hvert hul efter nettoscore. Den bedste bold tager fire, midterspilleren to og den dårligste nul. Spillere med samme placering deler pointene for de pladser, de optager, så en delt føring giver tre hver, og en delt sidsteplads giver fire til vinderen og et til hver af de andre. Den, der mangler en score på hullet, deler de nederste pladser."
        }
      },
      "b1f4b6d5-3a7e-4d0a-8d3b-2e4f6a7b8c9d": {
        "standard": {
          "name": "Standard",
          "description": "Et hul trækkes i hemmelighed, før runden starter, og ingen får at vide hvilket. Alle spiller alle atten huller som normalt, og først bagefter afsløres hullet, og den bedste score på det tager præmien. Da man aldrig ved, hvilket hul der tæller, er den eneste måde at spille på at spille hvert hul ordentligt."
        }
      },
      "90c0ba8c-0fb0-4f5e-9a9e-4d2e8b1b0cc1": {
        "standard": {
          "name": "Standard",
          "description": "Tre matcher spillet på én gang på en enkelt runde: de første ni, de sidste ni og hele runden. Hver afgøres for sig, så at tabe de første ni koster dig én match og intet mere. Den, der er bagud, kan kalde en press, som starter en helt ny match, der løber fra det hul til slutningen af segmentet og giver en vej tilbage uden at røre de matcher, der allerede er i gang."
        },
        "front-back-only": {
          "name": "Kun ud og ind",
          "description": "De samme to nihullers matcher, ud og ind, uden en separat match over hele runden. En god forni er i hus i stedet for at blive åbnet igen af den samlede match, hvilket passer et selskab, der hellere spiller to korte dyster end én lang. Press fungerer præcis som i den fulde variant."
        }
      },
      "6b9c72e0-6c1c-4d17-9f1f-6c0e2f71a742": {
        "standard": {
          "name": "Standard",
          "description": "Et sidespil for de slag, ingen vil have. Et hul, hvor du får et strafslag, er et point værd, talt én gang per hul, uanset hvordan strafslaget opstod. Som med de andre uheldsspil skal I på forhånd beslutte, om vinderen er den med flest eller færrest."
        }
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760003": {
        "standard": {
          "name": "Standard",
          "description": "Belønningen for at komme rent ud af problemer. Var du i bunkeren på et hul og alligevel gik i mål i par eller bedre, er hullet et point værd. Det bedømmes på faktiske slag, så det er up-and-down, der giver det, og intet andet."
        }
      },
      "d06818bc-beea-41cc-8c59-2c176d46ef53": {
        "standard": {
          "name": "Standard",
          "description": "Hvert hul er en skin værd. Skinnen går til den, der alene har den laveste nettoscore, og kun direkte: deler to eller flere den bedste score, vinder ingen den. Et delt hul fører sin skin videre til det næste, så puljen vokser, indtil nogen vinder et hul alene og tager hele bunken. En stille runde kan afgøres på et enkelt sent hul."
        },
        "no-carry": {
          "name": "Ingen overførsel",
          "description": "Hvert hul er en skin værd, som vindes direkte af den ene laveste nettoscore. Et delt hul er ganske enkelt ugyldigt: intet føres videre, og den skin er væk. Hvert hul er derfor højst én skin værd, hvilket holder spillet jævnt i stedet for at lade et sent hul afgøre det hele."
        }
      },
      "3fb77a04-e479-4cd7-9ed8-8e8e110b4c53": {
        "standard": {
          "name": "Standard",
          "description": "Hvert hul giver point mod par på din nettoscore. En par giver to point, et mere for hvert slag bedre og et mindre for hvert slag dårligere. Et hul kan aldrig give minus, så et katastrofehul koster ikke ekstra. Slag tildeles efter handicap: et på hvert hul plus et ekstra på de sværeste huller efter slagindeks, indtil handicappet er brugt. Samler du bolden op, giver hullet nul. Den højeste total efter runden vinder."
        },
        "gross": {
          "name": "Brutto",
          "description": "Den samme pointtabel, men spillet uden handicap. Ingen får slag, så scoren på kortet er den, der tæller. Alt andet er uændret: en par giver to point, bedre giver mere, dårligere giver mindre, og intet hul går under nul."
        }
      },
      "c9d4b6a8-2a75-4d4f-bc35-9b0ec5b2f60b": {
        "standard": {
          "name": "Standard",
          "description": "Almindeligt slagspil: tæl hvert slag og læg dem sammen. Handicapslag trækkes fra, så totalen er din nettoscore for runden, og den laveste total vinder. Der er intet at holde styr på hul for hul, hvilket gør det til det mest retfærdige billede af, hvem der faktisk spillede bedst."
        },
        "gross": {
          "name": "Brutto",
          "description": "Den samme optælling af hvert slag, men uden handicap. Der trækkes intet handicap fra, så det laveste antal faktiske slag vinder. Sådan afgøres et klubmesterskab."
        }
      },
      "e1c62b4f-59a0-4b82-9c58-e4c6276933d0": {
        "standard": {
          "name": "Standard",
          "description": "Et pars to nettoscorer sættes sammen til ét tocifret tal med den laveste bold først: et fire og et seks bliver seksogfyrre, ikke fireogtres. De to hold sammenligner tal, og forskellen mellem dem er hullets resultat. Fordi en dårlig bold flytter det andet ciffer, koster en svag score langt mere her end i de fleste holdspil."
        }
      },
      "e0b7c8af-3dc8-4a9f-8b77-5d99e5da0a4b": {
        "standard": {
          "name": "Standard",
          "description": "Et sidespil, der tæller uheld i stedet for godt spil. Et hul, hvor du finder vandet, er et point værd, og et hul tæller højst én gang, uanset hvor mange gange du ryger i. Om pointene er noget at samle på eller noget at undgå, må selskabet blive enige om før runden."
        }
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760002": {
        "standard": {
          "name": "Standard",
          "description": "Den samme belønning, men for vand i stedet for sand. Finder du vandet på et hul og alligevel går i mål i par eller bedre, er hullet et point værd. Med det strafslag, der som regel følger med, er dette det sværeste af de to at opnå."
        }
      },
      "4a6d988d-2077-4c1d-b6d6-e74f82d73115": {
        "standard": {
          "name": "Standard",
          "description": "Spillerne skiftes til at være ulven i en fast rækkefølge, der roterer hvert hul. Ulven slår ud sidst og ser de andre, og vælger derefter enten en af dem som makker for hullet eller siger nej til alle og spiller alene mod resten. At gå alene er mere værd, hvis det lykkes, og koster mere, hvis det ikke gør, så hele spillet ligger i timingen af den beslutning."
        }
      },
      "1b06cb5e-6edc-4d95-9c27-f008d9db7b98": {
        "standard": {
          "name": "Standard",
          "description": "Spejlbilledet af best ball og langt sværere, end det lyder. På hvert hul er holdets højeste nettoscore den, der tæller, så ingen kan gemme sig, og alle skal spille hullet færdigt. Hver spiller med den score får pointet. Det straffer ét sjusket hul på en måde, best ball aldrig gør."
        }
      },
      "eab96a21-05ee-4a7d-8cdb-13ec27752158": {
        "standard": {
          "name": "Standard",
          "description": "Holdene samler netto-Stablefordpoint, og antallet af scorer, der tæller, vokser, efterhånden som runden skrider frem. Det begynder med kun den bedste bold på holdet, derefter de to bedste efter en tredjedel af runden, de tre bedste efter to tredjedele, og alle scorer på de afsluttende huller: seks, seks, fire og to over atten huller, eller tre, tre, to og et over ni. Antallet overstiger aldrig holdets størrelse, så et par når blot sit loft tidligt. Hver spiller bærer holdets total."
        }
      }
    }
  },
  "freeze": {
    "title": "Eclectic Freeze",
    "subtitle": "Lås Stablefordpoint på huller, du er tilfreds med. Låste huller ændres aldrig.",
    "loading": "Indlæser…",
    "loadError": "Kunne ikke indlæse Eclectic Freeze.",
    "noPlayers": "Ingen spillere at vise endnu.",
    "chipLockedCount": "{locked} låst",
    "lockedAvg": "gns. {avg}",
    "selectHint": "Vælg huller at låse for {name}.",
    "windowClosed": "Låsevinduet er lukket for denne spiller.",
    "windowOtherRound": "Denne spiller låser fra en anden runde.",
    "openEarlierLabel": "Åbn denne tidligere runde for frysning",
    "openEarlierHint": "Sæt kryds for alligevel at låse huller fra denne runde.",
    "allLocked": "Alle huller er låst.",
    "lockedTotalLabel": "Låst",
    "selectedLabel": "Valgt",
    "afterLockLabel": "Efter låsning",
    "avgLabel": "Gns.",
    "lockButton": "Lås {count} huller",
    "saving": "Låser…",
    "permanentNote": "Låsning er permanent. Vinduet lukker, når næste runde starter.",
    "confirmTitle": "Lås huller?",
    "confirmMessage": "Lås {count} huller for {name}? Dette kan ikke fortrydes.",
    "confirmCta": "Lås permanent",
    "cancel": "Annuller",
    "lockSaved": "{count} huller låst.",
    "lockRejected": "Kunne ikke låse hullerne.",
    "lockTimeout": "Intet svar. Prøv igen.",
    "switchTitle": "Kassér valgte huller?",
    "switchMessage": "Du har {count} valgte huller for {name}, som ikke er låst endnu. Skift spiller og kassér dem?",
    "switchCta": "Skift og kassér",
    "switchStay": "Behold valget",
    "done": "Færdig"
  },
  "claimSignup": {
    "title": "Behold dine scores",
    "body": "Opret en konto for at beholde dine scores og bruge dem på alle enheder.",
    "cta": "Opret konto og behold dine scores"
  },
  "privacy": {
    "title": "Privatlivspolitik",
    "updated": "Sidst opdateret {date}",
    "intro": "Goffy registrerer golfrunder. Vi gemmer det, der skal til, og intet andet. Vi sælger ikke dine oplysninger, viser ingen reklamer og bruger ingen tredjepartssporing.",
    "collectH": "Hvad vi indsamler",
    "collectP": "Din e-mailadresse og adgangskode, dit spillernavn og – hvis du tilføjer dem – handicap, køn og foto samt de runder og resultater, du spiller. Appen sender også målinger af ydeevne, så vi kan finde fejl.",
    "locationH": "Placering",
    "locationP": "Når du starter en runde, beder vi om din placering for at vise baner i nærheden. Koordinaterne bruges kun til den søgning og gemmes ikke. Siger du nej, fungerer alt andet som normalt.",
    "sharingH": "Hvem ser det",
    "sharingP": "De, du spiller med, ser de runder, du deler med dem. Ingen andre, medmindre loven kræver det.",
    "storageH": "Hvor det gemmes",
    "storageP": "På servere i Irland, krypteret under overførsel. Runder gemmes, så længe din konto findes.",
    "rightsH": "Dine rettigheder",
    "rightsP": "Du kan se og rette din profil og slette din konto under Profil i menuen. Sletningen fjerner dit login, din profil og dine personlige oplysninger. Resultater bliver stående på andre spilleres scorekort med dit navn, fordi en sletning ville skrive en andens runde om. Vil du have en kopi af dine oplysninger, så skriv til privacy@goffy.app.",
    "contactH": "Kontakt",
    "contactP": "privacy@goffy.app"
  },
  "courseMapping": {
    "title": "Banekortlægning",
    "intro": "Goffy kan lære, hvor tees og greens ligger på de baner, du spiller, ved at registrere din position under en runde. Det er slået fra, indtil du slår det til.",
    "toggleLabel": "Hjælp med at kortlægge de baner, jeg spiller",
    "unsupported": "Banekortlægning findes indtil videre kun på Android.",
    "whatH": "Hvad der registreres",
    "whatP": "Din position, cirka hvert tredje sekund, mens en runde er i gang. Registreringen stopper, når runden slutter. Der registreres intet mellem runder.",
    "whyH": "Hvad det bruges til",
    "whyP": "Positioner fra mange spillere kombineres for at finde ud af, hvor hver tee og green ligger. Resultatet er et kort over banen, ikke en optegnelse over din runde. Dine positioner gemmes under en kode, der er forskellig på hver bane, så de ikke kan samles til en historik over, hvor du har været.",
    "batteryH": "Hvad det koster",
    "batteryP": "Regn med omkring 10-15% mere batteriforbrug over en fire timers runde. Registrering starter aldrig under 20% batteri og stopper, hvis du kommer ned på 20% undervejs.",
    "retentionH": "Hvor længe det gemmes",
    "retentionP": "Rå positioner slettes efter 90 dage. De tee- og greenpositioner, der er beregnet ud fra dem, bevares, fordi de er det, kortet består af, og de handler ikke om en enkelt spiller.",
    "controlH": "Du bestemmer",
    "controlP": "Slå fra når som helst, så stopper registreringen med det samme. Sletter du din konto, slettes dine registrerede positioner med den. Når en bane er fuldt kortlagt, holder Goffy op med at registrere der af sig selv."
  },
  "courseMappingReview": {
    "title": "Gennemgå banekortlægning",
    "intro": "Tee- og greenpositioner beregnet ud fra spillernes GPS-spor. Hver position er et gennemsnit, og sikkerheden viser, hvor meget man kan stole på den. Godkend en position for at gøre den officiel, afvis for at slette den.",
    "selectCourse": "Bane",
    "empty": "Der er endnu ikke beregnet noget for denne bane. Positioner dukker op, når nok runder er registreret.",
    "hole": "Hul {number}",
    "tee": "Tee",
    "green": "Green",
    "reviewed": "godkendt",
    "meta": "{confidence}% sikkerhed · {contributors} bidragydere",
    "accept": "Godkend",
    "reject": "Afvis"
  },
  "courseHoleMap": {
    "openButton": "Vis kortlagte huller",
    "title": "Banekortlægning",
    "overviewTitle": "Baneoversigt",
    "overviewCounter": "{total} huller",
    "holeTitle": "Hul {hole}",
    "empty": "Denne bane har endnu ingen huller at vise.",
    "meta": "{source} · {confidence}% sikkerhed · {contributors} bidragydere",
    "shapeMeta": "{area} · {points} punkter · hul {hole}",
    "basemap_esri-worldimagery": "Esri",
    "basemap_lantmateriet-orto": "Lantmäteriet",
    "basemap_drawing": "Tegning",
    "source_esri-worldimagery": "Esri",
    "source_lantmateriet-orto": "Lantmäteriet",
    "source_osm": "OSM",
    "close": "Luk",
    "shapeKind_bunker": "Bunker",
    "shapeKind_water": "Vand",
    "shapeKind_green": "Greenflade",
    "shapeKind_fairway": "Fairway",
    "shapeKind_trees": "Træer",
    "counter": "{index} af {total} huller",
    "edit": "Rediger positioner",
    "editDone": "Færdig",
    "placeTee": "Tilføj tee",
    "placeGreen": "Angiv green",
    "revert": "Fortryd ændringer",
    "save": "Gem",
    "saving": "Gemmer…",
    "saved": "Positionerne er gemt. Billedanalyse er sat i kø for banen.",
    "saveFailed": "Kunne ikke gemme positionerne. Intet blev ændret.",
    "remove": "Fjern",
    "editHint": "Vælg Tilføj tee eller Sæt green, og klik derefter på stedet på kortet. Træk for at panorere — koordinaten der vises er midten af visningen.",
    "armedHint": "Klik på kortet for at placere.",
    "unsavedWarning": "Gem eller fortryd ændringerne på hullet først.",
    "closeWarning": "Luk igen for at kassere de ugemte ændringer.",
    "goto": "Gå",
    "gotoPlaceholder": "Breddegrad, længdegrad",
    "gotoInvalid": "Kunne ikke læse det som breddegrad og længdegrad. Prøv \"56.6776, 12.8578\".",
    "analyse": "Analysér",
    "analysing": "Sætter i kø…",
    "analysisQueued": "I kø til billedanalyse. Den kører inden for få minutter.",
    "analysisUnavailable": "Billedanalyse er ikke konfigureret i dette miljø.",
    "analysisFailed": "Kunne ikke sætte billedanalyse i kø.",
    "savedAndMoved": "Gemt. Banens position lå langt herfra, så den er flyttet hertil og sat i kø til analyse.",
    "basemapUnavailable": "Intet Lantmäteriet-billede gemt for denne bane endnu."
  },
  "subscriptionPage": {
    "title": "Abonnement",
    "signInPrompt": "Log ind for at administrere dit abonnement.",
    "loading": "Indlæser din abonnementsstatus…",
    "error": "Kunne ikke indlæse din abonnementsstatus.",
    "statusNone": "Du har ikke et aktivt abonnement endnu.",
    "statusActive": "Dit abonnement er aktivt. Fornyes {date}.",
    "statusActiveCancelling": "Dit abonnement er aktivt indtil {date}, hvorefter det ophører.",
    "statusPastDue": "Din seneste betaling mislykkedes. Opdater din betalingsmetode for at beholde abonnementet.",
    "statusCancelled": "Dit abonnement er ophørt.",
    "upgradeButton": "Abonnér",
    "manageButton": "Administrer abonnement",
    "checkoutError": "Kunne ikke starte betalingen. Prøv igen.",
    "portalError": "Kunne ikke åbne abonnementsstyring. Prøv igen.",
    "featureDisabled": "Abonnementer er ikke tilgængelige endnu.",
    "successMessage": "Tak! Dit abonnement bliver sat op.",
    "cancelledMessage": "Betalingen blev annulleret."
  },
  "subscriptionAdminPage": {
    "title": "Betalinger og abonnementer",
    "forbidden": "Kun for administratorer.",
    "loading": "Indlæser abonnementer…",
    "error": "Kunne ikke indlæse abonnementer.",
    "empty": "Ingen abonnementer endnu.",
    "status": "Status",
    "cancelling": "ophører",
    "price": "Pris",
    "renews": "Fornyes",
    "updated": "Opdateret",
    "stripeIds": "Stripe-kunde/abonnement"
  },
  "golfCourseAdminPage": {
    "title": "Golfbaneadministration",
    "forbidden": "Kun for administratorer.",
    "totalCourses": "{count} baner i kataloget",
    "loadingCourses": "Indlæser baner…",
    "loadCoursesError": "Kunne ikke indlæse baner.",
    "searchPlaceholder": "Søg baner efter navn, klub eller id",
    "searchNoMatches": "Ingen baner matcher.",
    "filterAll": "Alle",
    "filterAnalysed": "Analyseret",
    "filterNotAnalysed": "Ikke analyseret",
    "countryAll": "Alle lande",
    "selectAllShown": "Markér alle viste",
    "selectedCount": "{count} markeret",
    "analyzeSelected": "Analysér markerede",
    "clearSelection": "Ryd",
    "pageRange": "{from}–{to} af {total} · side {page}/{pages}",
    "previousPage": "Forrige",
    "nextPage": "Næste",
    "osmFilterGreens": "OSM-greens",
    "osmFilterHoles": "OSM-huller",
    "osmFilterBunkers": "OSM-bunkere",
    "osmFilterFairways": "OSM-fairways",
    "courseCardOsmFeatures": "OSM-data: {greens} greens · {holes} huller · {bunkers} bunkere · {fairways} fairways",
    "analysisUnknown": "Ukendt",
    "courseCardDetails": "Par {par} · {holes} huller · {visibility}",
    "courseCardCoordinates": "{lat}, {lon}",
    "courseCardOsm": "OSM {osmType}/{osmId}",
    "osmSectionTitle": "OSM-data fundet",
    "osmNotImported": "Ikke importeret fra OSM.",
    "osmCountsError": "Kunne ikke hente OSM-data.",
    "osmCounts": "{holes} huller · {greens} greens · {tees} teesteder · {terrain} terrænelementer",
    "analysisSectionTitle": "Hvad vi har analyseret",
    "findOsmButton": "Find golfbaner fra OSM",
    "modalTitle": "Importer golfbaner fra OpenStreetMap",
    "countryLabel": "Land",
    "withHoleDataLabel": "Kun med huldata",
    "importButton": "Importer",
    "importing": "Importerer…",
    "progressSearching": "Søger i OpenStreetMap…",
    "progressFound": "Fandt {count} baner",
    "progressCheckingHoleData": "Kontrollerer huldata: {checked}/{total}",
    "progressCheckingHoleDataWithImports": "Kontrollerer huldata: {checked}/{total} ({imported} importeret indtil videre)",
    "progressImporting": "Importerer {count} baner…",
    "resultSummary": "Importerede {imported}, sprang {skipped} allerede eksisterende over",
    "resultFailed": "{failed} kunne ikke importeres",
    "importedListTitle": "Importerede baner",
    "error": "Import mislykkedes. Prøv igen.",
    "backfillButton": "Udfyld manglende analyse",
    "backfillRunning": "Udfylder…",
    "backfillProgress": "{matched} matchet via OSM, {triggered} startet uden match, {failed} mislykkedes",
    "backfillDone": "Færdig: {matched} matchet via OSM, {triggered} startet uden match, {failed} mislykkedes",
    "backfillError": "Kunne ikke udfylde. Prøv igen.",
    "close": "Luk",
    "flyoverButton": "Flyvetur",
    "flyoverModalTitle": "Render flyveture: {name}",
    "flyoverExplainer": "Flyveturvideoer renderes lokalt, én gang pr. bane (kræver Lantmäteriet-dækning). Kopiér kommandoen og indsæt i en terminal i repoets rod — scriptet åbner et login-link; godkend det i den browser, du allerede er logget ind i. Kræver AWS-adgang, ffmpeg og course-analysis-tjenestens Python-venv. Fjern --dry-run for at uploade resultatet.",
    "flyoverCopy": "Kopiér kommando",
    "flyoverCopied": "Kopieret",
    "flyoverWorkerExplainer": "Flyover-videoer renderes af en batch-worker på din egen maskine (kræver Lantmäteriet-dækning). Sæt renderingen i kø her; den starter, når en worker er online, og banen fyldes hul for hul.",
    "flyoverRender": "Render på batch-worker",
    "flyoverRequesting": "Sætter i kø…",
    "flyoverQueued": "I kø. Videoerne dukker op, efterhånden som hullerne bliver færdige.",
    "flyoverRenderFailed": "Kunne ikke sætte renderingen i kø.",
    "flyoverNoHoles": "Intet hul har både tee og green; intet at flyve.",
    "flyoverWorkerOnline": "En batch-worker er online.",
    "flyoverWorkerOffline": "Ingen batch-worker er online — jobbet venter, indtil en tændes.",
    "flyoverLastJob": "Seneste rendering: {status} ({rendered} renderet, {skipped} sprunget over)",
    "flyoverShowCommand": "Render på denne computer i stedet…",
    "flyoverHideCommand": "Skjul kommandoen",
    "flyoverJobStatus": {
      "queued": "i kø",
      "succeeded": "lykkedes",
      "failed": "mislykkedes"
    },
    "osmRefreshButton": "Opdater OSM",
    "osmRefreshRunning": "Opdaterer OSM…",
    "osmRefreshResult": "OSM opdateret: {written} nye, {updated} ændrede, {removed} fjernede, {unchanged} uændrede",
    "osmRefreshFailed": "OSM-opdatering mislykkedes"
  },
  "deleteAccountPage": {
    "title": "Slet din Goffy-konto",
    "updated": "Sidst opdateret {date}",
    "intro": "Du kan slette din Goffy-konto, når du vil. Her står, hvad der fjernes, hvad der bliver, og hvordan du gør.",
    "removedH": "Det her slettes",
    "removedP": "Dit login, din profil og oplysningerne på den — billede, handicap, køn og hjemmeklubber. Sletningen er permanent og kan ikke fortrydes.",
    "keptH": "Det her bliver",
    "keptP": "Runder og tours, du har spillet, bliver stående på de andre spilleres scorekort, stadig med dit navn, fordi en sletning ville skrive en andens runde om.",
    "inAppH": "I appen",
    "inAppP": "Åbn menuen, gå til Profil, og brug Slet min konto nederst på siden.",
    "signedOutH": "Hvis du ikke kan logge ind",
    "signedOutP": "Skriv til privacy@goffy.app fra adressen på kontoen, så sletter vi den for dig."
  },
  "terms": {
    "title": "Tjenestevilkår",
    "updated": "Sidst opdateret {date}",
    "intro": "Goffy gemmer golfrunder. Det her er vilkårene for at bruge tjenesten. Kort sagt: vær ordentlig, brug Goffy til golf, og hold din konto sikker.",
    "accountH": "Din konto",
    "accountP": "Du er ansvarlig for det, der sker på din konto. Hold din adgangskode for dig selv, og brug et navn, dine medspillere kan genkende — scorekort deles med dem, du spiller med.",
    "fairUseH": "Fair brug",
    "fairUseP": "Misbrug, angrib eller forstyr ikke tjenesten, og brug den ikke til at chikanere andre spillere. Vi kan lukke en konto, der gør det.",
    "dataH": "Dine oplysninger",
    "dataP": "Vi gemmer de kontooplysninger, der skal til for at drive tjenesten, og ikke mere. Hvad vi indsamler, hvor det opbevares, og hvordan du får det slettet, står i privatlivspolitikken.",
    "warrantyH": "Ingen garanti",
    "warrantyP": "Goffy leveres, som den er. Vi gør vores bedste for at holde resultater sikre og tjenesten kørende, men vi kan ikke garantere, at den er fejlfri eller altid tilgængelig, og et resultat, der registreres her, er ikke en officiel handicapregistrering.",
    "changesH": "Ændringer",
    "changesP": "Vilkårene kan blive opdateret med tiden. Datoen ovenfor ændres, når de gør."
  },
  "about": {
    "title": "Om",
    "version": "Version",
    "build": "Build",
    "commit": "Commit",
    "buildDate": "Byggedato",
    "licensesHeading": "Open source-licenser",
    "licensesIntro": "Goffy er bygget med {count} open source-pakker. Tryk på en for at se dens licens.",
    "licenseTextUnavailable": "Licensteksten er ikke tilgængelig.",
    "close": "Luk"
  },
  "ai": {
    "playAgainstAi": "Spil mod AI-spillere",
    "revealMode": "AI-resultater",
    "revealInAdvance": "Vis på forhånd",
    "revealAsIScore": "Vis når vi har scoret",
    "addAiPlayer": "Tilføj AI-spiller",
    "pureAi": "AI-spiller",
    "ghostOfMe": "Spøgelse af mig",
    "ghostOfFriend": "Spøgelse af en ven",
    "aiBadge": "AI",
    "ghostBadge": "Spøgelse",
    "pendingReveal": "Vises når alle har scoret",
    "ghostNamePrefix": "Spøgelset {name}",
    "aiCreateFailed": "Kunne ikke oprette AI-spilleren. Prøv igen.",
    "aiPlayersHint": "AI-spillere og mennesker deler samme liste — maks. {count} i alt."
  },
  "courseAnalysis": {
    "title": "Analyse af banedata",
    "adminOnly": "Denne side er kun tilgængelig for administratorer.",
    "failed": "Kunne ikke indlæse banens data.",
    "empty": "Ingen kortlagt data for banen endnu.",
    "holeTitle": "Hul {hole}",
    "unattributed": "Ikke knyttet til et hul",
    "reports": "Rapporter",
    "reportBadge": "{count} rapporteret unøjagtig",
    "noFeatures": "Ingen kortlagte objekter.",
    "meta": "Sikkerhed {confidence}% · {state}",
    "reviewed": "gennemgået",
    "unreviewed": "ikke gennemgået",
    "polygon": "polygon",
    "centreOnly": "kun centrumpunkt, ingen grænse",
    "sampleCount": "{count} bidragydere",
    "kind": {
      "tee": "Tee",
      "green": "Green",
      "bunker": "Bunker",
      "water": "Vand",
      "other": "Andet",
      "fairway": "Fairway",
      "trees": "Træer"
    },
    "source": {
      "osm": "OSM",
      "gps": "GPS",
      "satellite": "Satellit"
    },
    "guide": {
      "title": "Baneguide — hul {hole}",
      "length": "{metres} m",
      "unavailable": "For lidt geometri til at tegne hullet. Tee og green er minimum.",
      "arcsNote": "Buerne er meter til greenens forkant.",
      "missingCover": "Mangler i kortet: {kinds} — kør satellitanalysen igen for at udfylde billedet.",
      "derivedNotice": "Tegnet ud fra ugennemset satellitanalyse. Fairwaykanten adskilles fra roughen alene på klippehøjde, og trælinjen er en skyggegradient — betragt hver grænse som et forslag.",
      "nothingMapped": "Ingen grænser kortlagt for hullet — kun tee- og greenpositionerne er kendt. Satellitanalysen har endnu ikke givet polygoner for banen."
    },
    "status": {
      "open": "Baneanalyse",
      "title": "Baneanalyse",
      "failed": "Kunne ikke hente analysestatus.",
      "endpointMissing": "Denne backend har ikke analyse-endpointet endnu. Frontend er foran geodata-service — deploy den (migreringen kører ved opstart), så udfyldes panelet.",
      "attempts": "Forsøg {attempts} af {max}",
      "requestedAt": "Anmodet",
      "analysedAt": "Analyseret",
      "never": "aldrig",
      "lastRun": "Seneste kørsel",
      "neverRun": "Der er aldrig kørt en analyse for denne bane.",
      "durationSeconds": "Tog {seconds} s",
      "durationMinutes": "Tog {minutes} min {seconds} s",
      "stored": "Gemte objekter",
      "noFeatures": "Ingen objekter gemt for denne bane.",
      "featureMeta": "{count} fra {source} · {polygons} med grænser",
      "run": "Kør analyse nu",
      "running": "Anmoder…",
      "queued": "I kø. Analysen tager den inden for få minutter — åbn panelet igen for at se resultatet.",
      "runFailed": "Kunne ikke anmode om analyse.",
      "queueDepth": "Analysekø",
      "queueDepthCount": "{count} venter på tværs af alle baner",
      "queueDepthUnknown": "Kunne ikke læse køens størrelse.",
      "worker": "Batch-worker",
      "workerOnline": "En worker er online og tager analyser i kø.",
      "workerOffline": "Ingen worker er online. Analyser i kø venter, indtil en tændes.",
      "workerRow": "{id} · version {version}",
      "workerVersionUnknown": "udviklingsbuild",
      "workerBusy": "optaget",
      "state": {
        "disabled": "Slået fra",
        "neverRequested": "Aldrig anmodet",
        "pending": "Afventer",
        "abandoned": "Opgivet",
        "analysed": "Analyseret"
      },
      "explain": {
        "disabled": "Der er ingen billedanalyse konfigureret i dette miljø, så ingen bane kan analyseres. Det er et spørgsmål om deploy og konfiguration — en ny kørsel hjælper ikke.",
        "neverRequested": "Banen har aldrig været i kø til analyse — sandsynligvis importeret før funktionen fandtes. En kørsel nu er alt, der skal til.",
        "pending": "I kø og venter på baggrundsloopet, som tager baner med et interval.",
        "abandoned": "Analysen brugte sine forsøg og gentages ikke af sig selv. Se seneste kørsel nedenfor for årsagen, og kør igen når den er løst.",
        "analysed": "En kørsel er gennemført for banen. Seneste kørsel nedenfor viser, hvad den gav."
      },
      "providerLine": "{provider}: {written} skrevet, {replaced} erstattet, {skipped} sprunget over (stærkere kilde) · fliser {fetched}/{attempted}",
      "providerFailed": "mislykkedes: {error}",
      "providerPartial": "billederne er ufuldstændige",
      "runStatus": {
        "dispatched": "Venter på worker",
        "running": "Kører",
        "succeeded": "Lykkedes",
        "partial": "Delvist",
        "failed": "Mislykkedes"
      }
    }
  },
  "shotTrackingDebug": {
    "title": "Fejlfinding slagmåling",
    "developersOnly": "Denne side er kun tilgængelig for udviklere.",
    "status": "Status",
    "audio": "Lyd live",
    "noAudio": "Ingen lyddata — mikrofonen åbnes, når du står stille, eller straks når puttesten kører.",
    "simulate": "Simuler træf",
    "simulated": "Træf injiceret i den rigtige kæde.",
    "noSession": "Lydoptagelse utilgængelig på denne enhed — håndledstoppe fra uret vises stadig.",
    "clear": "Ryd log",
    "startSession": "Start testsession",
    "stopSession": "Stop testsession",
    "sessionFailed": "Kunne ikke starte testsession: {reason}",
    "puttTest": "Puttest",
    "puttTestHint": "Holder mikrofonen åben (virker indendørs, ingen GPS nødvendig) og sender intet til runden. Siden foreslår en kandidat for hver putt, den hører eller mærker — bedøm hver enkelt, og tryk \"Overset putt\", når du puttede, uden at noget blev foreslået. Kandidater født ved et knaptryk frasorteres som knaplyd.",
    "puttTestStart": "Start puttest",
    "puttTestStop": "Stop puttest",
    "marks": "Markeringer sendt fra denne enhed",
    "server": "Fusionerede slag fra serveren",
    "log": "Hændelseslog",
    "none": "Intet endnu.",
    "close": "Luk",
    "judgePrompt": "bedøm nedenfor",
    "listening": "Lytter — put når du er klar.",
    "verdictCorrect": "Rigtig putt",
    "verdictWrong": "Ikke en putt",
    "verdictMissed": "Overset putt",
    "puttEstimateSummary": "{correct} rigtige · {wrong} forkerte · {missed} oversete · {pending} ubedømte"
  },
  "schedule": {
    "title": "Planlæg runde",
    "heading": "Planlæg en runde",
    "teeTimeLabel": "Starttid",
    "pickTeeTime": "Vælg starttid",
    "pickCourse": "Bane",
    "nameLabel": "Rundens navn (valgfrit)",
    "namePlaceholder": "Rundens navn",
    "holesLabel": "Huller",
    "holes18": "18 huller",
    "holes9": "9 huller",
    "submit": "Planlæg runde",
    "submitting": "Planlægger...",
    "success": "Runden er planlagt.",
    "missingCourse": "Vælg en bane først.",
    "missingTeeTime": "Vælg en starttid først.",
    "error": "Runden kunne ikke planlægges.",
    "rejected": "Runden kunne ikke planlægges.",
    "creatingTour": "Forbereder...",
    "upcomingTitle": "Kommende runder",
    "scheduleRoundCta": "Planlæg runde",
    "notifyByEmail": "Send invitationer via e-mail",
    "notifyByEmailHint": "Medlemmer ser den altid i appen – e-mail er valgfrit."
  },
  "rsvp": {
    "title": "Tilmelding",
    "heading": "Kommer du?",
    "teeTime": "Starttid",
    "course": "Bane",
    "accept": "Kommer",
    "decline": "Kommer ikke",
    "maybe": "Måske",
    "whoIsComing": "Hvem kommer",
    "respondedAt": "Svarede {time}",
    "noResponses": "Ingen svar endnu.",
    "comingCount": "{count} kommer",
    "loading": "Indlæser...",
    "loadError": "Runden kunne ikke indlæses.",
    "sending": "Gemmer dit svar...",
    "sendError": "Dit svar kunne ikke gemmes.",
    "statusInvited": "Inviteret",
    "statusAccepted": "Kommer",
    "statusDeclined": "Kommer ikke",
    "statusTentative": "Måske",
    "myStatusLabel": "Dit svar"
  },
  "mlModels": {
    "open": "Modeller",
    "close": "Luk",
    "title": "Detektormodeller",
    "unavailable": "Backend har intet modelregister endnu.",
    "failed": "Kunne ikke hente modelregistret.",
    "empty": "Ingen modeller registreret endnu. Træn en med training/train.py --register.",
    "model": "Model",
    "score": "P {p} · R {r} · F1 {f1}",
    "legend": "Seneste evaluering pr. type: precision · recall · F1 mod OSM/godkendte objekter.",
    "datasets": "{count} registrerede datasæt."
  }
}
